var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWelleNeuHintenNeu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1920 554.89",
    style: {
      enableBackground: "new 0 0 1920 554.89"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_00000143616744772324806300000006488517477687357834_);}\n\t.st2{fill:url(#SVGID_00000144326639144371711240000018124512434843473822_);}\n\t.st3{fill:url(#SVGID_00000066493035184352717120000015045684632171734925_);}\n\t.st4{fill:url(#SVGID_00000132076296577680095250000009782067568889442950_);}\n\t.st5{fill:url(#SVGID_00000042708297761855142460000002972276226415348905_);}\n\t.st6{fill:url(#SVGID_00000052104611866339040070000010421060873057230264_);}\n\t.st7{fill:url(#SVGID_00000114791553993821295720000011037004585612091310_);}\n\t.st8{fill:url(#SVGID_00000022523461715883447670000004069920875336636823_);}\n\t.st9{fill:url(#SVGID_00000054233211335148393660000010305830370191561893_);}\n\t.st10{fill:url(#SVGID_00000029727432041112083780000009518014044988295359_);}\n\t.st11{fill:url(#SVGID_00000137097136137762320070000011715183867118703026_);}\n\t.st12{fill:url(#SVGID_00000142137889602282564520000006681276262762639287_);}\n\t.st13{fill:url(#SVGID_00000049211147459384042040000005132578056078204094_);}\n\t.st14{fill:url(#SVGID_00000074408011426673046760000014281949763947217310_);}\n\t.st15{display:none;}\n\t.st16{display:inline;fill:url(#SVGID_00000173149527330911495270000012712057315769537183_);}\n\t.st17{display:inline;fill:url(#SVGID_00000119838720776675273550000017795173776077989809_);}\n\t.st18{display:inline;fill:url(#SVGID_00000165220464755142079370000010257481851337906337_);}\n\t.st19{display:inline;fill:url(#SVGID_00000057828504960284261520000009939191464708367537_);}\n\t.st20{display:inline;fill:url(#SVGID_00000160871068709280071250000003000053528506888583_);}\n\t.st21{display:inline;fill:url(#SVGID_00000030449144093219628470000012379282028739865251_);}\n\t.st22{display:inline;fill:url(#SVGID_00000095326098642655793550000000813778468530092213_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -334.6318,
    y1: 32.7339,
    x2: 2079.6919,
    y2: 32.7339
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2681,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3068,
    style: {
      stopColor: "#E8FAF7",
      stopOpacity: 0.0528
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3871,
    style: {
      stopColor: "#BDF1E9",
      stopOpacity: 0.1627
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4716,
    style: {
      stopColor: "#98E9DD",
      stopOpacity: 0.2782
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5594,
    style: {
      stopColor: "#7AE2D3",
      stopOpacity: 0.3982
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6515,
    style: {
      stopColor: "#62DDCB",
      stopOpacity: 0.5241
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7498,
    style: {
      stopColor: "#52DAC5",
      stopOpacity: 0.6586
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8588,
    style: {
      stopColor: "#48D8C2",
      stopOpacity: 0.8076
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9995,
    style: {
      stopColor: "#45D7C1"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M647.76,462.71c-2.07,0-4.14-0.06-6.2-0.19c-30.8-1.9-61.37-15.96-96.18-44.27   c-7.8-6.35-15.72-13.3-23.53-20.66c-8.23-7.75-16.39-15.95-24.28-23.88c-19.46-19.57-39.59-39.81-62.02-54.42   c-42.82-27.91-87.8-29.39-110.8-27.79c-29.96,2.09-53.86,9.22-77.5,23.14l-0.87,0.52c-4.19,2.5-9.41,5.61-17.4,3.81   c-4.92-1.1-9.73-4.36-13.85-7.32c-9.64-6.9-18.99-14.14-27.66-20.95c-4.06-3.19-8.11-6.39-12.15-9.58   c-41.49-32.8-80.69-63.77-129.6-78.31c-28.63-8.58-60.67-10.6-92.66-5.85c-24.2,3.57-47.79,10.81-70.13,21.52   c-12.38,5.97-24.13,13.38-35.5,20.55c-17.42,10.99-35.44,22.36-55.66,28.37c-3.38,1-6.37,0.76-8.9-0.73   c-7.09-4.16-10.03-17.16-14.47-36.85c-1.14-5.06-2.32-10.29-3.7-15.94c-1.32-5.4-3.21-10.98-5.21-16.88   c-2.58-7.61-5.51-16.25-7.64-25.95c-6.08-27.57-7.23-63.1-7.56-90.97c-1.08-91.49-5.91-192.29-13.24-276.55   c-6.52-74.96-18.58-176.74-47.88-195.07c-5.22-3.27-10.71-3.73-16.78-1.4l-1.01-2.65c6.86-2.63,13.35-2.07,19.3,1.65   c23.12,14.46,38.75,77.13,49.2,197.23c7.34,84.33,12.17,185.21,13.25,276.76c0.33,27.74,1.48,63.07,7.5,90.4   c2.1,9.55,4.88,17.74,7.56,25.65c2.02,5.97,3.93,11.6,5.28,17.12c1.38,5.66,2.57,10.91,3.71,15.98   c4.12,18.28,7.1,31.49,13.14,35.03c1.85,1.09,4.03,1.24,6.66,0.45c19.85-5.9,36.9-16.66,54.96-28.05   c11.43-7.21,23.26-14.67,35.78-20.71c22.6-10.83,46.46-18.15,70.94-21.77c32.4-4.81,64.87-2.75,93.89,5.94   c49.43,14.69,88.83,45.83,130.54,78.8c4.04,3.19,8.08,6.39,12.15,9.58c8.64,6.78,17.96,14.01,27.56,20.87   c3.89,2.8,8.41,5.87,12.81,6.86c6.89,1.54,11.38-1.13,15.33-3.48l0.89-0.53c23.71-13.96,48.73-21.43,78.74-23.52   c23.36-1.62,69.03-0.11,112.54,28.25c22.68,14.78,42.91,35.12,62.48,54.8c7.87,7.92,16.02,16.1,24.21,23.82   c7.76,7.31,15.62,14.22,23.37,20.52c34.33,27.91,64.38,41.78,94.57,43.64c40.31,2.54,84.69-20.59,113.04-58.88   c6.16-8.32,11.87-16.84,17.39-25.08c18.3-27.31,35.58-53.1,66.22-68.03c15.07-7.33,32.15-10.24,43.68-11.79   c23.27-3.2,46.86-3.66,70.11-1.34c38.01,3.93,75.53,15.35,111.53,33.94c12.24,6.28,24.39,13.28,36.14,20.04   c22.85,13.16,44.44,25.59,63.58,31.07c4.7,1.38,8.98,2.3,12.17,2.95c23.5,4.72,38.55,2.24,60.55-2.42   c12.21-2.58,26.64-5.8,45.68-10.06c3.49-0.78,7.07-1.57,10.74-2.37c12.32-2.7,25.06-5.5,38.39-9.07c7.93-2.12,16.05-4.52,23.9-6.85   c32.92-9.75,66.95-19.83,99.82-13c3.67,0.76,7.33,1.72,10.9,2.87c16.83,5.44,31.28,15.95,45.26,26.12c3.05,2.22,6.2,4.51,9.31,6.7   c16.68,11.72,40.61,5.64,73.16-18.59l0.23-0.17l0.28-0.07c31.55-7.5,78.92-26.86,125.41-76.47c8.75-9.33,16.88-21.14,24.74-32.55   c11.06-16.06,22.5-32.68,36.11-43.14c78.45-60.35,146.04-98.31,200.89-112.81c45.29-11.98,80.34-6.7,98.69,14.86l-2.16,1.84   c-32.11-37.72-126.65-31.69-295.7,98.36c-13.26,10.19-24.57,26.62-35.51,42.5c-7.92,11.5-16.11,23.39-25,32.88   c-46.84,49.98-94.61,69.58-126.54,77.22c-33.54,24.91-58.48,30.95-76.25,18.46c-3.13-2.2-6.29-4.5-9.35-6.72   c-13.8-10.03-28.07-20.41-44.46-25.71c-3.47-1.12-7.03-2.06-10.6-2.79c-32.18-6.69-65.87,3.29-98.44,12.94   c-7.87,2.33-16.01,4.74-23.98,6.87c-13.4,3.59-26.17,6.39-38.52,9.1c-3.66,0.8-7.24,1.59-10.72,2.37   c-19.06,4.26-33.49,7.48-45.72,10.06c-22.36,4.73-37.67,7.25-61.7,2.42c-3.25-0.66-7.6-1.6-12.4-3.01   c-19.47-5.57-41.2-18.08-64.21-31.33c-11.72-6.75-23.83-13.72-36.02-19.98c-35.69-18.43-72.88-29.75-110.52-33.64   c-23.02-2.29-46.39-1.84-69.44,1.33c-11.34,1.52-28.12,4.38-42.83,11.53c-29.95,14.6-47.03,40.08-65.1,67.06   c-5.54,8.27-11.26,16.81-17.46,25.19C729.59,439.59,687.29,462.7,647.76,462.71z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000028324384505239868680000008740318595250476190_",
    gradientUnits: "userSpaceOnUse",
    x1: -332.1982,
    y1: 29.8205,
    x2: 2072.1089,
    y2: 29.8205
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2681,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3068,
    style: {
      stopColor: "#E8FAF7",
      stopOpacity: 0.0528
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3871,
    style: {
      stopColor: "#BDF1E9",
      stopOpacity: 0.1627
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4716,
    style: {
      stopColor: "#98E9DD",
      stopOpacity: 0.2782
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5594,
    style: {
      stopColor: "#7AE2D3",
      stopOpacity: 0.3982
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6515,
    style: {
      stopColor: "#62DDCB",
      stopOpacity: 0.5241
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7498,
    style: {
      stopColor: "#52DAC5",
      stopOpacity: 0.6586
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8588,
    style: {
      stopColor: "#48D8C2",
      stopOpacity: 0.8076
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9995,
    style: {
      stopColor: "#45D7C1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000028324384505239868680000008740318595250476190_)"
    },
    d: "M630.86,461.9   c-2.22,0-4.44-0.07-6.64-0.21c-30.75-1.94-62.44-16.46-96.89-44.39c-7.88-6.39-15.85-13.38-23.7-20.77   c-8-7.55-15.95-15.53-23.63-23.26c-19.86-19.97-40.4-40.62-63.51-55.17c-44.47-27.97-90.05-26.83-113.27-23.66   c-29.73,4.05-54.56,13.93-78.12,31.07l-0.64,0.47c-3.99,2.92-9.45,6.92-17.79,5.36c-5.01-0.94-9.9-4.16-14.09-7.11   c-10.19-7.15-19.84-14.62-27.93-20.98c-6.01-4.72-12.06-9.56-17.91-14.24c-39.62-31.69-77.04-61.62-123.79-76.15   c-28.75-9.02-60.97-11.22-93.17-6.38c-24.37,3.64-48.05,11.13-70.38,22.29c-12.47,6.26-24.27,14.07-35.67,21.62   c-17.25,11.42-35.08,23.23-55.26,29.57c-3.16,0.99-5.95,0.77-8.28-0.66c-6.84-4.18-9.24-18.06-12.86-39.06   c-0.92-5.32-1.86-10.81-2.99-16.76c-1.07-5.67-2.69-11.6-4.41-17.88c-2.14-7.83-4.57-16.7-6.28-26.54   c-3.85-22.11-5.34-50.53-4.85-92.16c1.04-89.64-1.04-191.58-5.73-279.68c-3.11-58.59-7.4-102.79-13.09-135.12   c-6.73-38.22-15.79-61.38-26.93-68.83c-4.4-2.95-9.08-3.49-14.3-1.65l-0.94-2.67c6.04-2.12,11.7-1.46,16.82,1.97   c21.74,14.55,34.47,78.13,41.28,206.16c4.68,88.16,6.77,190.16,5.73,279.86c-0.49,41.45,1,69.71,4.81,91.65   c1.69,9.7,3.99,18.13,6.22,26.27c1.73,6.33,3.37,12.32,4.46,18.1c1.13,5.97,2.08,11.48,2.99,16.8c3.36,19.51,5.8,33.61,11.54,37.12   c1.63,1,3.58,1.12,5.96,0.37c19.8-6.22,36.67-17.4,54.54-29.23c11.48-7.6,23.34-15.46,35.97-21.79   c22.61-11.29,46.57-18.88,71.23-22.56c32.62-4.91,65.28-2.67,94.43,6.47c47.26,14.68,84.88,44.78,124.72,76.64   c5.85,4.68,11.89,9.51,17.89,14.23c8.06,6.34,17.67,13.78,27.81,20.89c3.95,2.78,8.53,5.81,12.98,6.64   c7.13,1.33,11.62-1.96,15.59-4.86l0.65-0.47c23.96-17.43,49.19-27.47,79.41-31.59c23.6-3.22,69.93-4.37,115.16,24.07   c23.39,14.71,44.04,35.48,64.02,55.57c7.67,7.71,15.59,15.68,23.56,23.19c7.8,7.34,15.72,14.29,23.55,20.63   c33.97,27.54,65.14,41.86,95.28,43.77c20.98,1.35,43.06-3.95,63.85-15.31c19.38-10.6,37.09-26.36,49.87-44.39   c6.45-9.09,12.3-18.46,17.95-27.51c16.99-27.21,33.04-52.9,62.62-68.03c11.37-5.81,24.76-9.61,43.41-12.32   c23.16-3.42,46.67-4.17,69.88-2.23c38.03,3.31,75.68,13.92,111.89,31.51c11.35,5.48,22.68,11.57,33.63,17.46   c24.29,13.06,47.24,25.4,67.54,29.72c3.93,0.84,7.87,1.47,12.38,1.99c23.12,2.65,38.16-2.09,58.98-8.65l1.69-0.53   c15.67-4.94,30.03-9.14,45.19-13.22c6.71-1.81,13.7-3.55,21.11-5.4c8.96-2.23,18.22-4.54,27.71-7.15   c6.25-1.7,12.64-3.55,18.82-5.34c34.58-10,70.34-20.35,104.73-12.91c3.63,0.77,7.26,1.76,10.81,2.92   c16.74,5.48,31.26,15.78,45.29,25.75c3.06,2.17,6.21,4.41,9.33,6.56c17.47,12.02,41.78,7.49,74.3-13.87l0.25-0.16l0.29-0.05   c32.48-5.58,81.11-22.27,128.28-70.09c8.95-9.06,17.22-20.71,25.22-31.97c11.27-15.87,22.93-32.28,36.91-42.17   c79.22-56.06,148.11-88.96,204.75-97.78c44.53-6.93,80.41,1.92,101.02,24.92l-2.11,1.89c-19.95-22.26-54.92-30.79-98.47-24.01   c-56.21,8.75-124.7,41.48-203.55,97.29c-13.58,9.61-25.1,25.82-36.23,41.5c-8.07,11.35-16.41,23.1-25.52,32.32   c-47.56,48.21-96.64,65.14-129.53,70.84c-33.47,21.92-58.73,26.38-77.21,13.67c-3.13-2.16-6.3-4.41-9.36-6.58   c-13.86-9.84-28.2-20.02-44.53-25.37c-3.45-1.13-6.99-2.09-10.53-2.84c-33.69-7.29-69.1,2.95-103.34,12.86   c-6.19,1.79-12.6,3.65-18.86,5.35c-9.52,2.62-18.8,4.93-27.77,7.17c-7.39,1.84-14.37,3.58-21.05,5.38   c-15.12,4.07-29.45,8.27-45.08,13.19l-1.69,0.53c-21.16,6.67-36.45,11.48-60.16,8.76c-4.6-0.53-8.62-1.17-12.65-2.03   c-20.7-4.41-43.82-16.84-68.3-30c-10.93-5.88-22.23-11.95-33.52-17.4c-35.91-17.45-73.22-27.96-110.9-31.24   c-22.99-1.92-46.28-1.17-69.23,2.21c-18.33,2.66-31.44,6.38-42.53,12.04c-28.88,14.77-44.72,40.14-61.5,67.01   c-5.68,9.09-11.55,18.49-18.04,27.65c-13.21,18.64-30.78,34.28-50.82,45.24C670.53,456.47,650.35,461.9,630.86,461.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168106828842679427600000001108622773016815744_",
    gradientUnits: "userSpaceOnUse",
    x1: -329.8389,
    y1: 26.9044,
    x2: 2064.5073,
    y2: 26.9044
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2681,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3068,
    style: {
      stopColor: "#E8FAF7",
      stopOpacity: 0.0528
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3871,
    style: {
      stopColor: "#BDF1E9",
      stopOpacity: 0.1627
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4716,
    style: {
      stopColor: "#98E9DD",
      stopOpacity: 0.2782
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5594,
    style: {
      stopColor: "#7AE2D3",
      stopOpacity: 0.3982
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6515,
    style: {
      stopColor: "#62DDCB",
      stopOpacity: 0.5241
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7498,
    style: {
      stopColor: "#52DAC5",
      stopOpacity: 0.6586
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8588,
    style: {
      stopColor: "#48D8C2",
      stopOpacity: 0.8076
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9995,
    style: {
      stopColor: "#45D7C1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000168106828842679427600000001108622773016815744_)"
    },
    d: "M613.7,461.13c-2.3,0-4.59-0.07-6.87-0.22   c-31.09-2.01-63.02-16.57-97.6-44.52c-7.84-6.33-15.87-13.37-23.89-20.91c-7.86-7.41-15.65-15.25-23.2-22.83   c-20.2-20.3-41.08-41.29-64.8-55.7c-47.77-29.01-96.85-23.34-115.74-19.55c-30.08,6.03-55.11,18.43-78.76,39.02l-0.41,0.36   c-4,3.49-9.49,8.28-18.15,6.97c-5.12-0.78-10.09-3.98-14.35-6.91c-8.33-5.73-17.28-12.41-28.19-21.01   c-7.63-6.01-15.28-12.22-22.67-18.22C81.02,266.72,45.07,237.56,0.1,222.94c-28.9-9.46-61.28-11.84-93.63-6.89   c-24.54,3.7-48.31,11.46-70.65,23.05c-12.56,6.56-24.39,14.77-35.83,22.71c-17.08,11.85-34.75,24.11-54.88,30.79   c-2.95,0.99-5.55,0.8-7.7-0.56c-6.63-4.18-8.47-19.03-11.24-41.51c-0.68-5.51-1.39-11.2-2.23-17.37   c-0.81-5.94-2.15-12.23-3.57-18.88c-1.71-8.04-3.66-17.15-4.95-27.12c-2.95-22.68-3.6-51.48-2.12-93.38   c3.06-86.94,3.72-190.01,1.79-282.8c-1.87-89.8-7.19-195.15-31.96-212.91c-3.69-2.64-7.64-3.24-12.1-1.84l-0.85-2.7   c5.29-1.67,10.2-0.92,14.6,2.24c20.4,14.62,30.31,78.97,33.14,215.15c1.93,92.84,1.27,195.97-1.79,282.96   c-1.47,41.74-0.83,70.39,2.1,92.91c1.28,9.86,3.12,18.52,4.91,26.89c1.43,6.7,2.78,13.03,3.61,19.08   c0.85,6.18,1.56,11.89,2.24,17.41c2.58,20.9,4.45,36,9.94,39.46c1.42,0.9,3.16,0.99,5.3,0.27c19.75-6.55,36.46-18.15,54.16-30.43   c11.51-7.99,23.41-16.24,36.14-22.89c22.62-11.74,46.69-19.6,71.54-23.34c32.79-5.02,65.62-2.6,94.94,7   c45.47,14.78,81.62,44.11,119.89,75.16c7.39,5.99,15.03,12.19,22.64,18.19c10.86,8.56,19.77,15.21,28.04,20.9   c4,2.76,8.64,5.76,13.16,6.45c7.36,1.11,11.87-2.83,15.86-6.3l0.41-0.36c24.04-20.92,49.48-33.52,80.06-39.66   c40.61-8.14,83.54-0.88,117.77,19.91c24.02,14.58,45.02,35.7,65.34,56.12c7.53,7.57,15.31,15.39,23.13,22.77   c7.96,7.49,15.95,14.48,23.73,20.77c34.11,27.57,65.51,41.93,96,43.9c41.96,2.73,87.93-21.6,114.4-60.57   c6.64-9.79,12.53-19.93,18.22-29.74c15.78-27.2,30.68-52.89,59.31-68.23c14.35-7.68,30.59-10.9,43.15-12.84   c23.05-3.64,46.49-4.7,69.66-3.14c38.05,2.69,75.82,12.47,112.25,29.07c10.49,4.76,21.01,10.03,31.19,15.14   c25.7,12.89,49.97,25.06,71.43,28.14c4.14,0.59,8.37,0.94,12.57,1.06c21.79,0.66,36.33-5.55,54.76-13.41   c1.97-0.84,3.98-1.7,6.06-2.57c14.54-6.14,29.16-11.51,44.68-16.41c10.14-3.2,21.06-6.17,32.61-9.31   c5.21-1.42,10.53-2.86,15.91-4.37c4.2-1.17,8.41-2.37,12.64-3.58c36.59-10.44,74.41-21.23,110.68-13.07   c3.58,0.81,7.21,1.81,10.79,2.98c16.89,5.61,31.65,15.86,45.93,25.77c2.92,2.03,5.84,4.05,8.76,6.03   c18.25,12.32,42.93,9.32,75.45-9.16l0.26-0.15l0.29-0.03c33.39-3.61,83.24-17.58,131.15-63.64c9.15-8.8,17.57-20.29,25.72-31.41   c11.48-15.67,23.35-31.88,37.68-41.18c80.06-51.99,150.24-79.84,208.59-82.75c58.65-2.94,89.93,20.67,103.36,34.99l-2.07,1.94   c-13.09-13.97-43.66-36.97-101.15-34.1c-57.85,2.89-127.56,30.58-207.19,82.3c-13.9,9.02-25.61,25.02-36.94,40.48   c-8.21,11.22-16.71,22.81-26.04,31.78c-48.35,46.48-98.69,60.68-132.52,64.38c-33.41,18.93-58.99,21.84-78.18,8.9   c-2.94-1.99-5.86-4.02-8.79-6.05c-14.11-9.8-28.7-19.93-45.2-25.41c-3.49-1.14-7.03-2.12-10.52-2.9   c-35.55-8-73.03,2.69-109.28,13.03c-4.23,1.21-8.45,2.41-12.66,3.58c-5.39,1.51-10.71,2.95-15.93,4.37   c-11.52,3.13-22.41,6.09-32.5,9.27c-15.44,4.88-29.98,10.22-44.44,16.32c-2.07,0.87-4.08,1.73-6.05,2.57   c-18.74,7.99-33.54,14.31-55.95,13.63c-4.3-0.12-8.64-0.49-12.89-1.09c-21.92-3.15-46.39-15.42-72.3-28.41   c-10.15-5.09-20.65-10.35-31.09-15.09c-36.13-16.46-73.56-26.16-111.27-28.82c-22.95-1.54-46.17-0.49-69.02,3.11   c-12.33,1.91-28.28,5.07-42.25,12.54c-27.91,14.96-42.62,40.32-58.19,67.16c-5.72,9.85-11.63,20.05-18.33,29.91   c-12.71,18.71-30.78,35.08-50.88,46.08C653.74,455.68,633.41,461.13,613.7,461.13z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165922690465243056080000001510499511440552891_",
    gradientUnits: "userSpaceOnUse",
    x1: -327.4062,
    y1: 23.8998,
    x2: 2056.9165,
    y2: 23.8998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2681,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3068,
    style: {
      stopColor: "#E8FAF7",
      stopOpacity: 0.0528
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3871,
    style: {
      stopColor: "#BDF1E9",
      stopOpacity: 0.1627
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4716,
    style: {
      stopColor: "#98E9DD",
      stopOpacity: 0.2782
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5594,
    style: {
      stopColor: "#7AE2D3",
      stopOpacity: 0.3982
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6515,
    style: {
      stopColor: "#62DDCB",
      stopOpacity: 0.5241
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7498,
    style: {
      stopColor: "#52DAC5",
      stopOpacity: 0.6586
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8588,
    style: {
      stopColor: "#48D8C2",
      stopOpacity: 0.8076
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9995,
    style: {
      stopColor: "#45D7C1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000165922690465243056080000001510499511440552891_)"
    },
    d: "M596.49,460.28   c-2.35,0-4.69-0.08-7.02-0.23c-31.45-2.07-63.61-16.68-98.31-44.64c-7.92-6.38-16-13.45-24.03-21.03   c-7.69-7.25-15.32-14.93-22.71-22.35c-20.54-20.65-41.78-42-66.14-56.29c-49.36-28.94-99.12-20.43-118.22-15.43   c-30.5,7.99-55.73,22.92-79.4,46.97l-0.21,0.21c-4,4.07-9.47,9.64-18.45,8.61c-5.22-0.62-10.28-3.79-14.6-6.71   c-8.83-5.97-17.88-12.65-28.46-21.04c-9.07-7.17-18.12-14.63-26.87-21.84c-36.68-30.25-71.32-58.83-114.74-73.55   c-29.03-9.9-61.59-12.47-94.16-7.42c-24.72,3.78-48.57,11.79-70.91,23.83c-12.63,6.87-24.47,15.45-35.92,23.75   c-16.94,12.27-34.45,24.97-54.56,32.05c-2.76,0.97-5.17,0.81-7.16-0.49c-6.45-4.2-7.64-19.31-9.62-44.36   c-0.44-5.57-0.89-11.33-1.45-17.56c-0.56-6.26-1.61-12.94-2.72-20c-1.29-8.21-2.75-17.51-3.63-27.57   c-2.02-23.07-1.83-53.12,0.59-94.59c4.95-84.99,8.26-186.54,9.31-285.92c1.05-99.94-0.93-204.45-23.62-221.9   c-3.05-2.35-6.36-2.98-10.11-1.95l-0.76-2.73c4.6-1.27,8.84-0.45,12.59,2.43c10.52,8.09,17.48,33.02,21.27,76.2   c3.05,34.79,4.15,81.81,3.46,147.98c-1.05,99.43-4.36,201.02-9.31,286.05c-2.41,41.32-2.6,71.25-0.59,94.18   c0.87,9.96,2.26,18.81,3.61,27.38c1.12,7.11,2.17,13.83,2.74,20.19c0.56,6.24,1.02,12.01,1.46,17.59   c1.78,22.51,3.06,38.77,8.34,42.2c1.23,0.8,2.76,0.87,4.67,0.19c19.73-6.95,36.3-18.96,53.84-31.67   c11.52-8.35,23.44-16.99,36.23-23.94c22.63-12.19,46.8-20.31,71.83-24.13c33.02-5.11,66.05-2.51,95.5,7.54   c43.9,14.89,78.75,43.62,115.63,74.04c8.74,7.21,17.77,14.66,26.82,21.81c10.52,8.34,19.51,14.99,28.28,20.92   c4.05,2.74,8.75,5.7,13.34,6.24c7.6,0.88,12.12-3.72,16.11-7.78l0.21-0.21c24.05-24.43,49.69-39.59,80.7-47.72   c19.44-5.09,70.09-13.75,120.37,15.73c24.68,14.47,46.05,35.96,66.72,56.73c7.37,7.41,14.99,15.07,22.64,22.29   c7.98,7.53,16.01,14.55,23.87,20.88c34.23,27.58,65.87,41.98,96.72,44.02c43.07,2.88,89.32-21.8,115.09-61.41   c6.8-10.46,12.67-21.38,18.34-31.94c14.62-27.22,28.43-52.92,56.15-68.47c14.07-7.88,30.3-11.28,42.88-13.37   c22.95-3.87,46.31-5.23,69.43-4.05c38.08,2.07,75.97,11.04,112.62,26.65c9.88,4.18,19.82,8.81,29.44,13.3   c26.85,12.51,52.21,24.33,74.62,26.06c4.23,0.32,8.52,0.37,12.77,0.14c20.96-1.06,34.76-8.56,52.22-18.06   c2.82-1.53,5.72-3.11,8.74-4.71c14.24-7.54,29.1-14.12,44.16-19.57c13.5-4.91,28.44-9.16,44.25-13.67l8.84-2.52   c39.11-11.15,79.55-22.68,118.21-13.64c3.54,0.84,7.15,1.86,10.72,3.02c16.77,5.6,31.54,15.61,45.82,25.29   c2.98,2.02,5.95,4.03,8.93,6c19.07,12.62,44.12,11.17,76.59-4.44l0.26-0.12l0.29-0.01c34.29-1.64,85.38-12.9,134.03-57.23   c9.39-8.55,17.98-19.92,26.29-30.91c11.67-15.45,23.74-31.43,38.42-40.15c81.01-48.08,152.49-70.85,212.46-67.71   c53.73,2.83,87.13,26.05,105.68,45.04l-2.03,1.98c-18.2-18.63-50.99-41.41-103.8-44.19c-59.39-3.12-130.34,19.52-210.86,67.31   c-14.2,8.43-26.1,24.18-37.61,39.42c-8.38,11.1-17.05,22.58-26.64,31.3c-49.14,44.77-100.76,56.24-135.52,57.95   c-33.33,15.96-59.21,17.31-79.13,4.12c-2.99-1.98-5.97-4-8.96-6.02c-14.12-9.57-28.73-19.47-45.12-24.95   c-3.49-1.14-7.02-2.13-10.48-2.96c-37.94-8.87-78.02,2.56-116.78,13.61l-8.84,2.52c-15.77,4.49-30.66,8.74-44.06,13.61   c-14.94,5.4-29.68,11.93-43.8,19.41c-3.02,1.59-5.91,3.17-8.71,4.69c-17.08,9.29-31.83,17.3-53.43,18.4   c-4.36,0.23-8.78,0.19-13.13-0.14c-22.93-1.77-48.51-13.7-75.6-26.32c-9.6-4.47-19.52-9.1-29.35-13.26   c-36.35-15.48-73.92-24.37-111.66-26.42c-22.91-1.17-46.06,0.19-68.82,4.02c-12.35,2.04-28.28,5.38-41.96,13.04   c-27,15.14-40.62,40.5-55.03,67.34c-5.7,10.62-11.6,21.59-18.46,32.15C682.19,435.66,638.47,460.28,596.49,460.28z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000045611583039499900480000007635881970956859779_",
    gradientUnits: "userSpaceOnUse",
    x1: -324.9951,
    y1: 20.9119,
    x2: 2049.3267,
    y2: 20.9119
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2681,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3068,
    style: {
      stopColor: "#E8FAF7",
      stopOpacity: 0.0528
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3871,
    style: {
      stopColor: "#BDF1E9",
      stopOpacity: 0.1627
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4716,
    style: {
      stopColor: "#98E9DD",
      stopOpacity: 0.2782
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5594,
    style: {
      stopColor: "#7AE2D3",
      stopOpacity: 0.3982
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6515,
    style: {
      stopColor: "#62DDCB",
      stopOpacity: 0.5241
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7498,
    style: {
      stopColor: "#52DAC5",
      stopOpacity: 0.6586
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8588,
    style: {
      stopColor: "#48D8C2",
      stopOpacity: 0.8076
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9995,
    style: {
      stopColor: "#45D7C1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000045611583039499900480000007635881970956859779_)"
    },
    d: "M579.54,459.52   c-2.48,0-4.96-0.08-7.44-0.25c-31.82-2.16-64.21-16.8-99.02-44.77c-8.02-6.44-16.16-13.56-24.2-21.15   c-7.55-7.13-15.05-14.67-22.3-21.96c-20.86-20.97-42.43-42.66-67.41-56.8c-35.37-20.01-80.49-24.25-120.7-11.32   c-31.16,10.02-56.6,27.47-80.05,54.92l-0.1,0.12c-3.98,4.62-9.44,10.95-18.67,10.19c-5.32-0.45-10.45-3.6-14.84-6.51   c-8.55-5.63-17.68-12.33-28.72-21.07c-10.34-8.19-20.59-16.79-30.5-25.12c-35.47-29.79-68.98-57.93-111.06-72.77   c-29.14-10.33-61.87-13.08-94.66-7.93c-24.89,3.84-48.83,12.11-71.16,24.59c-12.75,7.18-24.65,16.17-36.15,24.87   c-16.75,12.66-34.07,25.76-54.11,33.22c-2.57,0.96-4.81,0.82-6.65-0.42c-6.3-4.2-6.91-20.55-7.93-47.63   c-0.21-5.5-0.42-11.19-0.7-17.32c-0.3-6.55-1.04-13.57-1.81-21c-0.92-8.82-1.88-17.94-2.36-28.15   c-1.12-23.74-0.06-54.18,3.31-95.79c6.67-82.57,12.64-185.23,16.82-289.04c4.19-104.54,5.67-213.73-15.14-231   c-2.5-2.07-5.23-2.73-8.34-2.02l-0.63-2.76c3.97-0.91,7.6-0.04,10.78,2.6c21.7,18.01,20.59,122.77,16.16,233.3   c-4.18,103.85-10.16,206.55-16.83,289.16c-3.37,41.49-4.42,71.81-3.31,95.43c0.48,10.13,1.43,19.21,2.35,27.99   c0.78,7.47,1.52,14.53,1.83,21.17c0.28,6.13,0.5,11.83,0.7,17.34c0.91,24.37,1.57,41.98,6.67,45.38c0.68,0.45,1.84,0.95,4.09,0.12   c19.65-7.32,36.8-20.28,53.39-32.82c11.58-8.75,23.55-17.8,36.47-25.08c22.63-12.65,46.89-21.03,72.12-24.92   c33.25-5.22,66.47-2.43,96.04,8.06C-1.96,255.39,33.3,285,67.41,313.64c9.89,8.31,20.13,16.9,30.44,25.07   c10.98,8.69,20.04,15.34,28.52,20.93c4.1,2.72,8.86,5.65,13.52,6.05c7.79,0.65,12.3-4.59,16.28-9.21l0.1-0.12   c23.81-27.86,49.66-45.59,81.34-55.78c40.96-13.16,86.92-8.85,122.97,11.55c25.31,14.33,47.02,36.16,68.02,57.26   c7.24,7.28,14.72,14.8,22.24,21.9c7.99,7.54,16.07,14.6,24.03,21c34.35,27.6,66.22,42.04,97.44,44.15   c21.92,1.5,44.69-3.84,65.84-15.44c20.36-11.16,38.09-27.79,49.92-46.81c6.91-11.08,12.68-22.73,18.27-34   c13.53-27.28,26.3-53.04,53.21-68.85c13.76-8.07,30-11.67,42.61-13.9c22.85-4.09,46.14-5.77,69.21-4.97   c38.14,1.44,76.15,9.59,112.99,24.21c9.24,3.64,18.57,7.68,27.6,11.59c28.03,12.12,54.5,23.58,77.91,23.87   c4.32,0.05,8.68-0.21,12.98-0.77c20.59-2.7,34.57-12.01,50.76-22.79c3.32-2.21,6.74-4.49,10.34-6.79   c13.85-8.91,28.53-16.56,43.64-22.74c14.9-6.16,31.83-11.24,47.9-15.92c44.35-12.91,84.21-22.84,122.89-13.45   c3.51,0.84,7.1,1.88,10.67,3.08c16.86,5.68,31.83,15.6,46.31,25.2c2.83,1.87,5.65,3.75,8.49,5.58   c19.94,12.92,45.38,13.02,77.77,0.28l0.26-0.1l0.28,0c35.22,0.36,87.53-8.2,136.91-50.82c9.58-8.27,18.3-19.48,26.74-30.32   c11.88-15.26,24.16-31.05,39.21-39.18c82.02-44.3,154.8-62.02,216.3-52.65c41.46,6.32,76.8,24.33,108.02,55.08l-1.99,2.02   c-30.78-30.31-65.61-48.07-106.46-54.3c-60.89-9.27-133.06,8.34-214.53,52.34c-14.52,7.85-26.62,23.39-38.32,38.43   c-8.52,10.95-17.33,22.28-27.12,30.73c-49.92,43.09-102.81,51.81-138.52,51.52c-33.18,12.99-59.38,12.78-80.09-0.64   c-2.84-1.84-5.67-3.72-8.51-5.6c-14.33-9.5-29.15-19.31-45.65-24.88c-3.49-1.18-7-2.19-10.43-3.01   c-38-9.22-77.47,0.62-121.43,13.42c-15.99,4.65-32.83,9.71-47.61,15.82c-14.95,6.12-29.48,13.69-43.19,22.51   c-3.58,2.29-7,4.57-10.3,6.77c-16.48,10.97-30.72,20.45-51.96,23.24c-4.43,0.58-8.94,0.84-13.39,0.8c-23.98-0.3-50.7-11.86-79-24.1   c-9.01-3.9-18.33-7.93-27.52-11.55c-36.53-14.5-74.23-22.58-112.04-24.01c-22.87-0.79-45.96,0.87-68.61,4.93   c-12.38,2.19-28.3,5.71-41.67,13.55c-26.18,15.38-38.77,40.78-52.1,67.67c-5.62,11.33-11.42,23.04-18.4,34.23   C666.3,434.56,622.47,459.52,579.54,459.52z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000126302536264412459830000008204927845460082852_",
    gradientUnits: "userSpaceOnUse",
    x1: -339.208,
    y1: 17.8579,
    x2: 2041.7397,
    y2: 17.8579
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2681,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3068,
    style: {
      stopColor: "#E8FAF7",
      stopOpacity: 0.0528
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3871,
    style: {
      stopColor: "#BDF1E9",
      stopOpacity: 0.1627
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4716,
    style: {
      stopColor: "#98E9DD",
      stopOpacity: 0.2782
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5594,
    style: {
      stopColor: "#7AE2D3",
      stopOpacity: 0.3982
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6515,
    style: {
      stopColor: "#62DDCB",
      stopOpacity: 0.5241
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7498,
    style: {
      stopColor: "#52DAC5",
      stopOpacity: 0.6586
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8588,
    style: {
      stopColor: "#48D8C2",
      stopOpacity: 0.8076
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9995,
    style: {
      stopColor: "#45D7C1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000126302536264412459830000008204927845460082852_)"
    },
    d: "M562.53,458.7   c-2.59,0-5.17-0.09-7.74-0.27c-32.18-2.22-64.8-16.91-99.73-44.9c-8.02-6.42-16.22-13.58-24.37-21.27   c-7.43-7.02-14.82-14.45-21.96-21.64c-21.16-21.28-43.04-43.29-68.6-57.22c-36.44-19.91-82.49-22.61-123.19-7.23   c-31.29,11.85-57.69,32.42-80.71,62.88c-3.94,5.19-9.33,12.27-18.86,11.79c-5.21-0.27-10.34-3.19-15.1-6.31   c-9.12-5.95-18.6-12.86-28.98-21.1c-11.52-9.14-22.87-18.84-33.84-28.23c-34.36-29.4-66.81-57.18-107.67-72.15   c-29.28-10.79-62.18-13.7-95.16-8.43c-25.07,3.92-49.1,12.45-71.43,25.36c-12.85,7.5-24.78,16.89-36.31,25.97   c-16.59,13.06-33.75,26.56-53.72,34.41c-2.39,0.94-4.46,0.82-6.17-0.34c-6.18-4.21-6.16-22.01-6.13-51.5   c0-5.18,0.01-10.68-0.02-16.47c-0.03-6.86-0.45-14.23-0.89-22.04c-0.51-9.02-1.03-18.36-1.12-28.7c-0.21-24.31,1.7-55.13,6-96.99   c10.57-102.74,19.08-215.59,24.35-292.17c7.89-114.62,12.57-223.04-6.43-240.13c-2.02-1.82-4.24-2.48-6.78-2.04l-0.49-2.79   c3.41-0.6,6.49,0.31,9.17,2.72c18.79,16.9,16.53,109.14,7.36,242.43c-5.27,76.6-13.78,189.48-24.35,292.26   c-4.29,41.75-6.2,72.47-5.99,96.68c0.08,10.28,0.61,19.58,1.12,28.57c0.44,7.84,0.86,15.25,0.9,22.18   c0.03,5.8,0.02,11.31,0.02,16.49c-0.02,25.58-0.04,45.79,4.9,49.15c0.57,0.39,1.56,0.82,3.54,0.04c19.59-7.71,36.58-21.08,53.01-34   c11.61-9.14,23.62-18.59,36.64-26.19c22.63-13.08,46.99-21.73,72.41-25.71c33.46-5.35,66.85-2.39,96.59,8.57   c41.34,15.15,75.5,44.38,108.54,72.66c10.95,9.37,22.27,19.06,33.76,28.17c10.32,8.19,19.73,15.04,28.77,20.94   c4.43,2.9,9.15,5.62,13.69,5.85c8.02,0.43,12.71-5.73,16.46-10.67c23.35-30.9,50.16-51.77,81.97-63.82   c41.47-15.67,88.4-12.91,125.55,7.39c25.92,14.14,47.95,36.29,69.25,57.71c7.13,7.17,14.5,14.58,21.9,21.57   c8.09,7.64,16.23,14.75,24.19,21.12c34.47,27.62,66.58,42.1,98.16,44.28c22.23,1.55,45.23-3.8,66.5-15.47   c20.67-11.33,38.41-28.25,49.95-47.63c6.93-11.63,12.55-23.96,17.97-35.89c12.48-27.42,24.27-53.33,50.44-69.4   c13.37-8.21,28.91-11.9,42.34-14.42c22.75-4.3,45.96-6.27,68.98-5.86c38.84,0.91,76.98,8.24,113.35,21.78   c8.65,3.16,17.42,6.67,25.9,10.06c29.15,11.65,56.68,22.66,81.07,21.5c4.4-0.22,8.84-0.79,13.18-1.7   c20.41-4.24,34.1-15.05,49.94-27.57c3.63-2.86,7.38-5.82,11.32-8.79c13.43-10.22,27.93-18.95,43.11-25.93   c15.36-7.11,32.67-12.61,47.58-17.05c40.46-12,83.32-21.75,122.67-11.85c3.52,0.88,7.09,1.93,10.61,3.12   c16.95,5.8,32.14,15.63,46.83,25.14c2.67,1.73,5.34,3.46,8.02,5.16c19.61,12.46,42.5,9.57,69.01,6.22   c3.34-0.42,6.73-0.85,10.19-1.26c4.43-0.52,8.94-1.01,13.51-1.5c39.98-4.32,85.3-9.22,126.55-42.92c9.79-8,18.67-19.07,27.26-29.78   c12.08-15.06,24.56-30.63,39.97-38.17c83.08-40.66,157.13-53.31,220.13-37.61c50.01,12.46,83.86,39.91,110.38,65.11l-1.95,2.05   c-26.25-24.94-59.74-52.1-109.11-64.41c-62.33-15.54-135.74-2.95-218.2,37.41c-14.83,7.26-27.12,22.58-39,37.39   c-8.68,10.82-17.65,22.01-27.67,30.2c-41.9,34.23-87.66,39.18-128.04,43.54c-4.57,0.49-9.06,0.98-13.49,1.5   c-3.45,0.41-6.83,0.83-10.16,1.26c-27.05,3.42-50.41,6.37-70.88-6.64c-2.68-1.71-5.36-3.44-8.04-5.17   c-14.54-9.41-29.58-19.15-46.2-24.83c-3.44-1.17-6.93-2.2-10.38-3.06c-38.7-9.73-81.11-0.07-121.18,11.82   c-14.81,4.41-32,9.87-47.2,16.9c-14.99,6.89-29.32,15.51-42.59,25.61c-3.93,2.95-7.66,5.91-11.28,8.76   c-16.13,12.74-30.06,23.74-51.12,28.12c-4.49,0.93-9.07,1.52-13.62,1.75c-25,1.19-52.82-9.93-82.27-21.7   c-8.46-3.38-17.21-6.88-25.83-10.03c-36.09-13.43-73.91-20.7-112.43-21.61c-22.82-0.41-45.83,1.54-68.39,5.81   c-13.18,2.48-28.41,6.08-41.39,14.05c-25.43,15.62-37.04,41.14-49.34,68.16c-5.46,11.99-11.1,24.4-18.12,36.16   c-11.8,19.81-29.92,37.09-51.02,48.66C603.55,453.2,582.85,458.7,562.53,458.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000118371369152891396280000014281406794143398334_",
    gradientUnits: "userSpaceOnUse",
    x1: -358.9213,
    y1: 14.8196,
    x2: 2034.1519,
    y2: 14.8196
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2681,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3068,
    style: {
      stopColor: "#E8FAF7",
      stopOpacity: 0.0528
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3871,
    style: {
      stopColor: "#BDF1E9",
      stopOpacity: 0.1627
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4716,
    style: {
      stopColor: "#98E9DD",
      stopOpacity: 0.2782
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5594,
    style: {
      stopColor: "#7AE2D3",
      stopOpacity: 0.3982
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6515,
    style: {
      stopColor: "#62DDCB",
      stopOpacity: 0.5241
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7498,
    style: {
      stopColor: "#52DAC5",
      stopOpacity: 0.6586
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8588,
    style: {
      stopColor: "#48D8C2",
      stopOpacity: 0.8076
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9995,
    style: {
      stopColor: "#45D7C1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000118371369152891396280000014281406794143398334_)"
    },
    d: "M545.28,457.89   c-2.62,0-5.23-0.09-7.85-0.28c-32.54-2.29-65.39-17.02-100.45-45.02c-8.14-6.49-16.17-13.49-24.56-21.4   c-7.3-6.9-14.56-14.19-21.58-21.25c-21.48-21.59-43.69-43.92-69.84-57.7c-37.52-19.78-84.51-20.94-125.7-3.1   c-31.89,13.84-58.5,37.01-81.37,70.85c-3.65,5.36-9.12,13.46-18.95,13.27c-5.53-0.12-10.82-3.21-15.34-6.1   c-9.18-5.88-18.75-12.79-29.25-21.13c-12.56-9.98-24.84-20.7-36.72-31.07c-33.38-29.14-64.92-56.67-104.73-71.81   c-29.39-11.22-62.47-14.33-95.67-8.98c-25.26,4-49.38,12.8-71.69,26.16c-12.95,7.82-24.91,17.61-36.49,27.07   c-16.43,13.44-33.42,27.33-53.31,35.6c-2.21,0.92-4.14,0.83-5.73-0.27c-6.08-4.22-5.37-23.74-4.18-56.08   c0.17-4.73,0.36-9.71,0.53-14.91c0.25-7.24,0.16-15.05,0.07-23.32c-0.1-9.15-0.21-18.62,0.09-29.01   c0.71-24.91,3.48-56.12,8.72-98.21c9.99-80.18,20.71-179.53,31.86-295.29c10.72-111.27,20.63-231.47,2.49-249.3   c-1.61-1.58-3.38-2.24-5.42-2l-0.32-2.82c2.9-0.33,5.5,0.61,7.73,2.8c17.18,16.88,12.11,108.78-1.65,251.59   c-11.16,115.79-21.88,215.16-31.87,295.37c-5.23,42-7.99,73.11-8.7,97.94c-0.29,10.33-0.19,19.77-0.08,28.89   c0.09,8.3,0.18,16.14-0.07,23.44c-0.17,5.21-0.35,10.19-0.53,14.92c-1.03,28.11-1.85,50.31,2.96,53.64   c0.48,0.33,1.31,0.69,3.02-0.02c19.51-8.11,36.33-21.87,52.6-35.18c11.65-9.53,23.7-19.38,36.82-27.31   c22.63-13.55,47.09-22.47,72.71-26.53c33.69-5.43,67.27-2.27,97.12,9.13c40.29,15.32,73.49,44.3,105.59,72.32   c11.85,10.35,24.11,21.05,36.62,30.99c10.42,8.28,19.91,15.14,29.01,20.96c4.19,2.68,9.07,5.55,13.87,5.66   c8.24,0.19,13.04-6.88,16.54-12.02c23.18-34.3,50.19-57.81,82.59-71.86c41.97-18.18,89.88-16.99,128.15,3.19   c26.53,13.98,48.9,36.47,70.53,58.21c7.01,7.04,14.25,14.32,21.51,21.19c8.33,7.85,16.3,14.8,24.38,21.25   c34.6,27.63,66.94,42.16,98.89,44.41c45.66,3.26,93.82-23.04,117.13-63.94c6.94-12.17,12.35-25.16,17.58-37.73   c11.48-27.6,22.33-53.66,47.8-70c13.05-8.36,28.59-12.25,42.07-14.95c22.43-4.49,45.34-6.76,68.09-6.76c0.22,0,0.44,0,0.66,0   c38.81,0.25,77.07,6.76,113.71,19.35c8.14,2.75,16.41,5.8,24.42,8.75c30.2,11.12,58.74,21.63,84.01,18.92   c4.5-0.5,9.01-1.38,13.4-2.62c20.44-5.76,33.92-18.13,49.54-32.46c3.81-3.49,7.74-7.1,11.89-10.7   c12.99-11.48,27.31-21.27,42.55-29.09c12.46-6.4,27.48-12.17,47.28-18.18c34.82-10.55,80.2-21.26,122.46-10.26   c3.5,0.91,7.05,1.97,10.55,3.18c17.11,5.9,32.56,15.67,47.51,25.12c2.46,1.56,4.92,3.11,7.39,4.65   c20.91,13,44.74,11.68,72.33,10.15c2.65-0.15,5.32-0.29,8.03-0.43c3.24-0.16,6.51-0.31,9.81-0.47   c42.1-1.93,89.82-4.12,133.12-37.56c10-7.73,19.02-18.65,27.74-29.22c12.28-14.88,24.97-30.26,40.76-37.18   c44.08-19.52,86.03-31.04,124.68-34.24c33.04-2.73,64.58,0.55,93.74,9.77c53.18,16.81,89.38,50.34,113.34,72.53   c1.69,1.57,3.34,3.09,4.93,4.55l-1.92,2.09c-1.59-1.47-3.24-2.99-4.94-4.56c-49.3-45.66-141.06-130.65-328.69-47.55   c-15.17,6.65-27.65,21.77-39.72,36.39c-8.82,10.69-17.94,21.74-28.19,29.66c-44.01,33.98-92.2,36.19-134.72,38.14   c-3.3,0.15-6.57,0.3-9.8,0.46c-2.7,0.14-5.37,0.28-8.01,0.43c-28.07,1.55-52.31,2.9-73.99-10.57c-2.47-1.54-4.94-3.1-7.41-4.66   c-14.81-9.36-30.12-19.04-46.92-24.83c-3.42-1.18-6.9-2.23-10.34-3.11c-41.58-10.82-86.47-0.22-120.93,10.23   c-19.63,5.95-34.5,11.67-46.8,17.99c-15.03,7.72-29.16,17.37-41.98,28.7c-4.12,3.58-8.05,7.18-11.84,10.66   c-15.22,13.96-29.6,27.15-50.69,33.1c-4.54,1.28-9.2,2.19-13.86,2.71c-25.95,2.79-54.78-7.83-85.3-19.07   c-7.99-2.94-16.25-5.98-24.35-8.72c-36.36-12.49-74.31-18.95-112.81-19.2c-22.76-0.04-45.72,2.21-68.19,6.71   c-13.22,2.65-28.44,6.45-41.1,14.55c-24.72,15.86-35.4,41.52-46.71,68.7c-5.26,12.65-10.7,25.73-17.73,38.05   C634.72,431.73,589.55,457.89,545.28,457.89z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088852176363897784550000011874016779438189758_",
    gradientUnits: "userSpaceOnUse",
    x1: -381.0099,
    y1: 11.6776,
    x2: 2026.5562,
    y2: 11.6776
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2681,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3068,
    style: {
      stopColor: "#E8FAF7",
      stopOpacity: 0.0528
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3871,
    style: {
      stopColor: "#BDF1E9",
      stopOpacity: 0.1627
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4716,
    style: {
      stopColor: "#98E9DD",
      stopOpacity: 0.2782
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5594,
    style: {
      stopColor: "#7AE2D3",
      stopOpacity: 0.3982
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6515,
    style: {
      stopColor: "#62DDCB",
      stopOpacity: 0.5241
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7498,
    style: {
      stopColor: "#52DAC5",
      stopOpacity: 0.6586
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8588,
    style: {
      stopColor: "#48D8C2",
      stopOpacity: 0.8076
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9995,
    style: {
      stopColor: "#45D7C1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000088852176363897784550000011874016779438189758_)"
    },
    d: "M528.32,457.05c-2.74,0-5.48-0.1-8.22-0.3   c-33-2.41-66.09-17.17-101.16-45.15c-8.23-6.55-16.54-13.79-24.7-21.52c-7.19-6.8-14.34-13.99-21.26-20.95   c-21.76-21.88-44.26-44.5-71.01-58.15c-20.21-10.29-42.52-15.1-66.33-14.32c-21.33,0.71-42.72,6.01-61.86,15.33   c-32.54,15.85-59.38,41.64-82.04,78.83c-3.57,5.83-8.97,14.63-19.03,14.76c-5.39,0.04-10.66-2.8-15.58-5.89   c-10.18-6.45-20.11-13.56-29.54-21.13C14.11,367.83,1,356.15-11.67,344.86c-31.09-27.7-63.23-56.35-102.13-71.67   c-29.51-11.66-62.76-14.94-96.16-9.5c-25.44,4.06-49.64,13.11-71.95,26.89c-13.06,8.15-25.07,18.34-36.69,28.19   c-16.27,13.8-33.09,28.06-52.88,36.76c-2.05,0.9-3.84,0.83-5.31-0.2c-5.77-4.06-4.77-21.81-1.98-61.59   c0.28-3.98,0.57-8.12,0.86-12.41c0.51-7.46,0.76-15.51,1.03-24.03c0.3-9.45,0.61-19.22,1.29-29.89   c1.64-25.62,5.27-57.21,11.42-99.41c11.5-78.8,24.38-176.41,39.38-298.41c14.22-115.71,28.01-240.66,11.55-258.51   c-1.27-1.38-2.66-2.01-4.27-1.95l-0.12-2.83c2.45-0.11,4.63,0.86,6.47,2.86c15.59,16.92,7.42,112.32-10.82,260.78   c-15,122.02-27.88,219.65-39.39,298.47c-6.14,42.13-9.77,73.64-11.4,99.19c-0.68,10.62-0.99,20.37-1.29,29.79   c-0.27,8.55-0.52,16.62-1.04,24.13c-0.29,4.29-0.58,8.43-0.86,12.41c-2.19,31.15-3.92,55.76,0.78,59.07   c0.39,0.28,1.08,0.57,2.54-0.07c19.42-8.53,36.08-22.66,52.19-36.33c11.69-9.92,23.79-20.17,37.02-28.44   c22.63-13.98,47.19-23.16,72.99-27.28c33.91-5.53,67.67-2.19,97.65,9.66c39.37,15.5,71.71,44.32,102.98,72.19   c12.65,11.27,25.72,22.92,39.15,33.61c9.34,7.51,19.19,14.55,29.28,20.95c4.24,2.66,9.18,5.54,14.04,5.45   c7.84-0.1,12.34-6.4,16.64-13.4c22.95-37.67,50.17-63.81,83.22-79.9c19.5-9.5,41.28-14.9,63.01-15.62   c24.29-0.81,47.07,4.12,67.71,14.63c27.15,13.86,49.81,36.64,71.73,58.68c6.9,6.94,14.04,14.12,21.2,20.89   c8.1,7.67,16.35,14.86,24.52,21.36c34.61,27.6,67.19,42.17,99.6,44.53c46.74,3.4,95.19-23.25,117.82-64.78   c6.9-12.66,12.06-26.29,17.05-39.48c10.52-27.8,20.46-54.07,45.28-70.68c12.9-8.62,28.37-12.66,41.81-15.47   c22.56-4.75,45.62-7.34,68.54-7.67c38.79-0.41,77.16,5.28,114.07,16.91c7.69,2.39,15.53,5.04,23.1,7.6   c31.18,10.55,60.64,20.51,86.79,16.18c4.6-0.77,9.18-1.97,13.61-3.54c20.48-7.27,34.46-21.88,49.27-37.36   c3.95-4.13,8.03-8.39,12.33-12.62c13.75-13.64,27.09-23.9,42-32.27c12.63-7.12,27.98-13.43,46.95-19.31   c48.37-14.95,88.36-17.78,122.25-8.66c3.49,0.93,7.02,2.02,10.49,3.23c17.31,6.03,33.08,15.76,48.34,25.18   c2.21,1.36,4.42,2.73,6.63,4.08c22.28,13.63,48.29,14,75.82,14.4c1.88,0.03,3.78,0.05,5.68,0.08l5.06,0.09   c44.56,0.78,95.06,1.66,140.75-31.69c10.21-7.46,19.38-18.24,28.25-28.67c12.47-14.67,25.37-29.84,41.5-36.16   c42.64-16.88,83.35-26.09,120.98-27.37c32.31-1.11,63.32,3.61,92.17,14.02c52.78,19.04,89.2,53.24,115.78,78.21   c4.95,4.65,9.62,9.04,13.93,12.88l-1.89,2.12c-4.34-3.87-9.03-8.27-13.99-12.93c-26.41-24.8-62.57-58.77-114.8-77.61   c-28.52-10.29-59.18-14.95-91.11-13.86c-37.31,1.28-77.7,10.42-120.04,27.18c-15.47,6.07-28.14,20.96-40.38,35.36   c-8.98,10.56-18.26,21.47-28.74,29.13c-46.46,33.91-97.47,33.02-142.47,32.23l-5.06-0.09c-1.9-0.03-3.79-0.06-5.68-0.08   c-27.93-0.4-54.32-0.78-77.26-14.81c-2.21-1.35-4.43-2.72-6.64-4.08c-15.12-9.33-30.76-18.99-47.78-24.91   c-3.4-1.19-6.86-2.25-10.29-3.17c-33.36-8.98-72.83-6.16-120.67,8.63c-18.77,5.82-33.95,12.06-46.4,19.07   c-14.68,8.25-27.83,18.35-41.4,31.81c-4.27,4.2-8.34,8.46-12.27,12.57c-15.04,15.72-29.26,30.57-50.37,38.07   c-4.59,1.63-9.33,2.86-14.1,3.66c-26.85,4.45-58.02-6.09-88.16-16.29c-7.56-2.56-15.38-5.2-23.04-7.58   c-36.63-11.54-74.72-17.18-113.19-16.78c-22.73,0.33-45.61,2.9-67.99,7.61c-13.17,2.76-28.31,6.7-40.81,15.05   c-24.07,16.11-33.85,41.96-44.2,69.33c-5.02,13.27-10.21,27-17.21,39.83C618.79,430.54,573.49,457.05,528.32,457.05z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155132036578811459890000017190418404429762965_",
    gradientUnits: "userSpaceOnUse",
    x1: -403.3395,
    y1: 8.6196,
    x2: 2018.9712,
    y2: 8.6196
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2681,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3068,
    style: {
      stopColor: "#E8FAF7",
      stopOpacity: 0.0528
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3871,
    style: {
      stopColor: "#BDF1E9",
      stopOpacity: 0.1627
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4716,
    style: {
      stopColor: "#98E9DD",
      stopOpacity: 0.2782
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5594,
    style: {
      stopColor: "#7AE2D3",
      stopOpacity: 0.3982
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6515,
    style: {
      stopColor: "#62DDCB",
      stopOpacity: 0.5241
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7498,
    style: {
      stopColor: "#52DAC5",
      stopOpacity: 0.6586
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8588,
    style: {
      stopColor: "#48D8C2",
      stopOpacity: 0.8076
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9995,
    style: {
      stopColor: "#45D7C1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000155132036578811459890000017190418404429762965_)"
    },
    d: "M511.38,456.32   c-2.88,0-5.75-0.11-8.63-0.32c-33.28-2.45-66.6-17.25-101.88-45.26c-8.24-6.54-16.6-13.83-24.86-21.65   c-7.11-6.73-14.19-13.85-21.03-20.73c-22.02-22.15-44.79-45.05-72.09-58.47c-20.34-9.99-43.72-14.47-67.61-12.96   c-21.88,1.39-43.69,7.64-63.09,18.08c-33.2,17.87-60.25,46.27-82.71,86.82c-3.5,6.29-8.79,15.8-19.09,16.19   c-5.72,0.22-11.17-2.81-15.82-5.68c-10.29-6.42-20.31-13.54-29.79-21.19c-14.34-11.44-28.18-24.04-41.57-36.22   c-30.33-27.6-61.7-56.15-99.78-71.66c-29.62-12.1-63.05-15.56-96.67-10.02c-25.63,4.14-49.92,13.45-72.21,27.67   c-13.17,8.49-25.24,19.09-36.92,29.35c-16.1,14.14-32.76,28.76-52.43,37.91c-2.37,1.1-3.98,0.53-4.92-0.14   c-5.72-4.07-3.96-23.91,0.58-68.39l0.88-8.6c0.78-7.73,1.38-16.06,2.01-24.88c0.7-9.71,1.41-19.74,2.48-30.63   c2.58-26.33,7.07-58.31,14.13-100.62c17.3-103.66,35.05-221.73,46.89-301.53c17.83-120.1,35.61-249.74,20.8-267.76   c-0.98-1.2-2.06-1.81-3.3-1.87l0.13-2.83c2.05,0.1,3.85,1.07,5.35,2.9c14.03,17.07,2.68,115.95-20.19,269.97   c-11.85,79.81-29.6,197.9-46.9,301.58c-7.05,42.25-11.54,74.16-14.11,100.43c-1.06,10.85-1.78,20.87-2.47,30.56   c-0.63,8.84-1.23,17.19-2.02,24.96l-0.88,8.6c-3.56,34.92-6.37,62.5-1.76,65.79c0.2,0.14,0.72,0.51,2.08-0.12   c19.3-8.97,35.8-23.46,51.75-37.47c11.75-10.32,23.9-20.99,37.26-29.6c22.62-14.43,47.28-23.88,73.28-28.08   c34.15-5.63,68.1-2.1,98.2,10.2c38.55,15.7,70.1,44.42,100.62,72.19c13.35,12.15,27.16,24.72,41.44,36.11   c9.39,7.58,19.31,14.64,29.5,20.99c4.29,2.64,9.3,5.43,14.22,5.26c8.04-0.3,12.67-7.44,16.73-14.73   c22.72-41.03,50.15-69.8,83.84-87.94c19.75-10.64,41.97-17,64.26-18.42c24.39-1.54,48.26,3.03,69.04,13.24   c27.73,13.62,50.67,36.7,72.85,59.01c6.83,6.87,13.89,13.97,20.97,20.67c8.2,7.77,16.5,14.99,24.67,21.49   c34.81,27.64,67.63,42.25,100.33,44.66c47.8,3.54,96.53-23.45,118.51-65.62c6.84-13.13,11.71-27.38,16.42-41.16   c9.58-28.04,18.64-54.53,42.86-71.43c12.66-8.82,28.1-13.04,41.53-16c22.45-4.98,45.42-7.86,68.27-8.58   c38.76-1.08,77.27,3.8,114.44,14.48c7.3,2.07,14.76,4.37,21.97,6.6c30.69,9.48,62.42,19.28,89.4,13.29   c4.7-1.06,9.36-2.56,13.83-4.47c20.73-8.8,34.65-25.18,49.38-42.52c3.97-4.67,8.08-9.51,12.39-14.28   c13.7-15.24,26.87-26.5,41.44-35.44c12.76-7.86,28.01-14.55,46.64-20.43c45.9-14.47,86.96-16.84,122.03-7.06   c3.55,0.99,7.06,2.09,10.42,3.28c17.62,6.19,33.8,15.95,49.44,25.38c1.86,1.12,3.73,2.25,5.59,3.36   c29.29,17.56,56.21,23.86,82.31,19.26c15.72-2.78,31.82-2.83,48.87-2.89c33.47-0.11,68.07-0.21,100.18-22.33   c10.44-7.19,19.76-17.84,28.78-28.14c12.67-14.46,25.76-29.42,42.25-35.15c178.48-62.61,271.54,28.02,327.15,82.18   c7.86,7.66,15.29,14.89,21.91,20.63l-1.86,2.14c-6.68-5.79-14.14-13.05-22.03-20.74c-55.13-53.69-147.4-143.57-324.24-81.53   c-15.78,5.48-28.63,20.15-41.05,34.34c-9.13,10.43-18.58,21.22-29.31,28.6c-32.83,22.61-67.88,22.72-101.78,22.83   c-16.92,0.05-32.91,0.1-48.39,2.84c-26.79,4.73-54.35-1.69-84.26-19.62c-1.87-1.12-3.73-2.24-5.6-3.37   c-15.52-9.36-31.57-19.04-48.92-25.13c-3.31-1.17-6.76-2.25-10.25-3.22c-34.53-9.63-75.05-7.27-120.42,7.04   c-18.4,5.82-33.45,12.41-46.01,20.15c-14.33,8.79-27.3,19.89-40.82,34.92c-4.28,4.74-8.38,9.56-12.33,14.22   c-14.95,17.6-29.08,34.23-50.43,43.3c-4.63,1.97-9.45,3.53-14.33,4.63c-27.72,6.15-59.82-3.76-90.86-13.35   c-7.2-2.22-14.64-4.52-21.91-6.58c-36.89-10.61-75.11-15.45-113.57-14.37c-22.67,0.71-45.46,3.57-67.74,8.51   c-13.17,2.9-28.28,7.02-40.52,15.56c-23.46,16.37-32.37,42.43-41.8,70.02c-4.74,13.88-9.65,28.23-16.59,41.55   C602.82,429.47,557.41,456.32,511.38,456.32z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005265272301076636680000012684052409876931976_",
    gradientUnits: "userSpaceOnUse",
    x1: -425.7884,
    y1: 5.439,
    x2: 2011.397,
    y2: 5.439
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2681,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3068,
    style: {
      stopColor: "#E8FAF7",
      stopOpacity: 0.0528
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3871,
    style: {
      stopColor: "#BDF1E9",
      stopOpacity: 0.1627
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4716,
    style: {
      stopColor: "#98E9DD",
      stopOpacity: 0.2782
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5594,
    style: {
      stopColor: "#7AE2D3",
      stopOpacity: 0.3982
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6515,
    style: {
      stopColor: "#62DDCB",
      stopOpacity: 0.5241
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7498,
    style: {
      stopColor: "#52DAC5",
      stopOpacity: 0.6586
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8588,
    style: {
      stopColor: "#48D8C2",
      stopOpacity: 0.8076
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9995,
    style: {
      stopColor: "#45D7C1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000005265272301076636680000012684052409876931976_)"
    },
    d: "M494.04,455.46   c-2.9,0-5.78-0.11-8.65-0.32c-33.6-2.49-67.16-17.34-102.59-45.4c-8.41-6.66-16.83-14-25.02-21.81   c-6.97-6.61-13.93-13.59-20.65-20.35c-22.34-22.45-45.44-45.65-73.33-58.96c-40.24-18.98-91.29-15.45-133.21,9.23   c-33.92,19.97-61.18,50.98-83.35,94.81c-3.22,6.34-8.6,16.94-19.19,17.64c-5.85,0.38-11.36-2.63-16.07-5.47   c-10.42-6.38-20.52-13.52-30.05-21.23c-15.12-12.09-29.62-25.56-43.63-38.59c-29.65-27.56-60.31-56.07-97.67-71.78   c-29.72-12.55-63.32-16.19-97.17-10.54c-25.98,4.34-51.04,14.17-72.47,28.43c-13.3,8.85-25.43,19.86-37.17,30.52   c-15.94,14.47-32.42,29.42-51.94,39.03c-2.19,1.08-3.69,0.55-4.57-0.07c-5.72-4.1-3-26.67,3.7-77.34l0.35-2.65   c1.05-7.91,1.97-16.42,2.96-25.42c1.1-10.06,2.23-20.46,3.7-31.68c3.48-26.64,8.99-59.95,16.84-101.84   c19.67-104.87,40.47-224.09,54.42-304.64c21.54-124.38,43.42-258.61,30.2-277.03c-0.76-1.05-1.58-1.63-2.51-1.78l0.43-2.8   c1.7,0.26,3.18,1.25,4.38,2.93c12.51,17.42-2.09,119.73-29.71,279.16c-13.94,80.56-34.76,199.79-54.42,304.68   c-7.84,41.84-13.34,75.1-16.81,101.68c-1.46,11.19-2.59,21.58-3.69,31.62c-0.99,9.02-1.92,17.54-2.96,25.48l-0.35,2.65   c-5.27,39.88-9.44,71.38-4.86,74.67c0.15,0.11,0.54,0.39,1.66-0.17c19.17-9.43,35.5-24.25,51.29-38.59   c11.81-10.72,24.03-21.81,37.51-30.78c21.76-14.48,47.2-24.46,73.57-28.86c34.37-5.74,68.52-2.03,98.73,10.73   c37.81,15.9,68.66,44.58,98.49,72.31c13.98,13,28.43,26.43,43.48,38.46c9.44,7.64,19.45,14.7,29.75,21.02   c4.34,2.62,9.39,5.4,14.41,5.07c8.29-0.55,12.87-8.25,16.84-16.09c22.42-44.33,50.04-75.72,84.44-95.97   c42.72-25.15,94.78-28.73,135.86-9.35c28.34,13.52,51.61,36.91,74.12,59.52c6.71,6.74,13.65,13.71,20.59,20.29   c8.13,7.75,16.49,15.03,24.83,21.64c34.98,27.69,68.03,42.34,101.04,44.79c23.15,1.74,47.74-3.79,69.21-15.58   c22.18-12.17,39.45-29.77,49.97-50.9c6.76-13.59,11.32-28.43,15.72-42.79c8.68-28.29,16.88-55.01,40.53-72.24   c12.41-8.99,27.83-13.38,41.26-16.5c22.37-5.2,45.27-8.39,68.08-9.47c38.76-1.72,77.37,2.35,114.78,12.11   c6.94,1.79,14.04,3.77,20.9,5.7c31.53,8.84,64.14,17.97,91.93,10.3c4.81-1.34,9.54-3.15,14.05-5.37   c21.04-10.36,34.95-28.59,49.67-47.88c3.93-5.16,8-10.49,12.26-15.73c13.57-16.79,26.55-29.06,40.87-38.61   c12.87-8.62,28.02-15.67,46.32-21.57c30.29-9.76,76.01-18.62,121.81-5.47c3.46,0.99,6.95,2.11,10.37,3.32   c18.02,6.38,34.68,16.21,50.8,25.71l4.28,2.52c30.88,18.16,57.43,25.79,83.53,24.01c14.23-0.98,29.18-0.3,43.64,0.35   c36.15,1.65,73.52,3.35,108.24-19.18c10.65-6.91,20.13-17.42,29.3-27.58c12.87-14.26,26.17-29,43.01-34.14   c41.04-12.63,80.35-17.85,116.83-15.51c31.48,2.02,61.9,9.76,90.42,22.99c52.37,24.31,89.26,61.96,118.91,92.22   c10.96,11.19,20.43,20.85,29.1,28.17l-1.83,2.17c-8.77-7.4-18.28-17.11-29.29-28.35c-29.48-30.09-66.18-67.55-118.07-91.63   c-28.2-13.09-58.28-20.74-89.41-22.74c-36.15-2.32-75.11,2.86-115.82,15.4c-16.09,4.9-29.13,19.35-41.73,33.32   c-9.29,10.3-18.9,20.95-29.86,28.06c-35.48,23.02-73.32,21.3-109.91,19.63c-15.04-0.68-29.25-1.33-43.32-0.36   c-26.7,1.83-53.77-5.93-85.16-24.39l-4.29-2.52c-16-9.44-32.55-19.2-50.31-25.48c-3.37-1.19-6.8-2.29-10.21-3.27   c-45.11-12.96-90.25-4.2-120.16,5.44c-18.05,5.81-32.97,12.76-45.61,21.23c-14.07,9.39-26.86,21.47-40.24,38.04   c-4.23,5.21-8.28,10.53-12.21,15.67c-14.93,19.57-29.03,38.05-50.67,48.71c-4.67,2.3-9.57,4.17-14.55,5.56   c-7.6,2.1-15.52,2.98-23.65,2.98c-22.4,0-46.39-6.72-69.81-13.28c-6.85-1.92-13.94-3.91-20.85-5.68   c-37.14-9.69-75.47-13.73-113.94-12.02c-22.63,1.08-45.37,4.24-67.57,9.4c-13.83,3.2-28.27,7.36-40.24,16.03   c-22.88,16.66-30.95,42.95-39.48,70.77c-4.44,14.47-9.03,29.43-15.89,43.22c-10.77,21.64-28.46,39.66-51.14,52.12   C536.88,449.81,515.12,455.46,494.04,455.46z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000063632607803429984500000002203654198409938607_",
    gradientUnits: "userSpaceOnUse",
    x1: -448.378,
    y1: 2.3608,
    x2: 2003.813,
    y2: 2.3608
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2681,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3068,
    style: {
      stopColor: "#E8FAF7",
      stopOpacity: 0.0528
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3871,
    style: {
      stopColor: "#BDF1E9",
      stopOpacity: 0.1627
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4716,
    style: {
      stopColor: "#98E9DD",
      stopOpacity: 0.2782
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5594,
    style: {
      stopColor: "#7AE2D3",
      stopOpacity: 0.3982
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6515,
    style: {
      stopColor: "#62DDCB",
      stopOpacity: 0.5241
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7498,
    style: {
      stopColor: "#52DAC5",
      stopOpacity: 0.6586
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8588,
    style: {
      stopColor: "#48D8C2",
      stopOpacity: 0.8076
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9995,
    style: {
      stopColor: "#45D7C1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000063632607803429984500000002203654198409938607_)"
    },
    d: "M477.03,454.66c-3,0-5.99-0.11-8.96-0.34   c-34-2.59-67.79-17.48-103.3-45.52c-8.34-6.59-16.83-13.96-25.22-21.89c-6.9-6.54-13.77-13.45-20.42-20.14   c-22.6-22.72-45.96-46.21-74.42-59.3c-41.23-18.78-93.23-13.66-135.72,13.35c-34.11,21.69-62.38,56.28-84.04,102.8   c-4.08,8.75-9.26,18.16-19.23,19.1c-5.7,0.54-11.21-2.24-16.31-5.31c-10.53-6.33-20.72-13.48-30.31-21.24   c-15.85-12.69-30.93-27.02-45.51-40.87c-29.03-27.57-59.04-56.08-95.74-72.01c-29.43-12.81-64.12-16.73-97.66-11.06   c-26.1,4.41-51.26,14.5-72.76,29.19c-13.44,9.22-25.67,20.67-37.5,31.74c-15.76,14.75-32.06,30.01-51.38,40.1   c-2.02,1.06-3.42,0.58-4.23-0.01c-5.46-3.93-2.33-27.09,6.68-82.98c1.25-7.75,2.44-16.01,3.7-24.76   c1.55-10.77,3.15-21.91,5.12-33.94c4.41-27.24,10.81-60.95,19.55-103.05c17.08-82.24,37.92-185.78,61.93-307.77   c13.53-68.75,28.43-146.45,36.32-201.49c9.89-68.99,6.29-85.12,1.53-86.51l0.79-2.72c5.96,1.73,11.4,13.49,0.49,89.63   c-7.88,54.96-22.12,129.39-36.34,201.64c-24.01,121.99-44.85,225.55-61.94,307.8c-8.73,42.06-15.12,75.72-19.53,102.93   c-1.96,12-3.57,23.13-5.11,33.89c-1.26,8.76-2.45,17.03-3.71,24.81c-6.09,37.82-12.4,76.93-7.82,80.23   c0.25,0.18,0.67,0.11,1.26-0.2c18.98-9.91,35.13-25.03,50.76-39.66c11.9-11.14,24.21-22.67,37.84-32.01   c21.84-14.92,47.39-25.18,73.88-29.65c34.58-5.85,68.9-1.96,99.27,11.25c37.15,16.13,67.35,44.81,96.56,72.55   c14.54,13.81,29.58,28.1,45.34,40.72c9.49,7.69,19.58,14.76,29.99,21.02c4.69,2.83,9.69,5.37,14.58,4.92   c8.47-0.8,13.18-9.44,16.92-17.47c21.89-47.02,50.52-82.01,85.09-104c43.29-27.53,96.33-32.71,138.42-13.54   c28.92,13.3,52.47,36.98,75.25,59.88c6.63,6.67,13.49,13.57,20.36,20.08c8.33,7.88,16.75,15.19,25.03,21.73   c35.06,27.68,68.34,42.37,101.76,44.91c23.48,1.79,48.31-3.74,69.92-15.6c22.48-12.33,39.76-30.21,49.97-51.71   c6.64-14,10.84-29.42,14.9-44.33c7.79-28.6,15.15-55.62,38.27-73.13c12.14-9.19,26.88-13.63,41-17.06   c22.27-5.43,45.09-8.92,67.83-10.38c38.75-2.41,77.5,0.83,115.16,9.63c6.64,1.54,13.44,3.25,20.01,4.91   c32.32,8.16,65.73,16.6,94.3,7.21c4.91-1.62,9.72-3.74,14.28-6.29c21.37-11.94,35.26-32.02,49.96-53.27   c3.9-5.63,7.93-11.46,12.13-17.17c8.43-11.51,21.79-28.36,40.3-41.78c12.7-9.2,28.18-16.84,46-22.71   c41.18-13.53,84.36-14.9,121.59-3.87c3.45,1.02,6.92,2.16,10.31,3.38c18.7,6.71,36.14,16.77,53,26.5l2.14,1.24   c22.08,12.72,51.66,27.48,84.75,28.77c11.61,0.45,23.66,1.66,35.32,2.83c39.89,4,81.13,8.14,119.37-15.21   c10.89-6.64,20.53-17.02,29.86-27.06c13.05-14.04,26.54-28.57,43.72-33.1c40.61-10.81,79.55-14.21,115.73-10.13   c31.26,3.53,61.54,12.81,89.99,27.56c52.31,27.13,89.89,67.5,120.1,99.95c13.46,14.46,25.09,26.95,35.62,35.62l-1.8,2.19   c-10.68-8.79-22.37-21.34-35.9-35.88c-30.05-32.28-67.46-72.46-119.33-99.36c-61.24-31.76-127.87-37.39-203.69-17.21   c-16.38,4.33-29.01,17.91-42.37,32.29c-9.46,10.18-19.24,20.7-30.46,27.55c-39.05,23.85-80.78,19.66-121.13,15.61   c-11.62-1.17-23.62-2.37-35.14-2.81c-33.71-1.31-63.69-16.26-86.05-29.14l-2.15-1.24c-16.75-9.66-34.08-19.66-52.54-26.29   c-3.35-1.2-6.76-2.32-10.16-3.33c-36.68-10.88-79.26-9.51-119.9,3.84c-17.54,5.77-32.75,13.27-45.22,22.31   c-18.19,13.18-31.35,29.8-39.68,41.16c-4.18,5.67-8.2,11.48-12.08,17.1c-14.9,21.53-28.96,41.87-50.91,54.13   c-4.71,2.64-9.68,4.83-14.77,6.51c-29.35,9.65-63.17,1.11-95.88-7.15c-6.56-1.66-13.35-3.37-19.96-4.9   c-37.4-8.73-75.87-11.95-114.34-9.56c-22.57,1.45-45.23,4.92-67.34,10.31c-13.82,3.36-28.23,7.69-39.96,16.57   c-22.35,16.93-29.59,43.49-37.25,71.61c-4.09,15.03-8.33,30.58-15.08,44.8c-10.47,22.04-28.17,40.36-51.17,52.98   C520.21,449,498.31,454.66,477.03,454.66z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000069396818640610437160000013441522880268571063_",
    gradientUnits: "userSpaceOnUse",
    x1: -471.0625,
    y1: 0,
    x2: 1996.2202,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2681,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3068,
    style: {
      stopColor: "#E8FAF7",
      stopOpacity: 0.0528
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3871,
    style: {
      stopColor: "#BDF1E9",
      stopOpacity: 0.1627
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4716,
    style: {
      stopColor: "#98E9DD",
      stopOpacity: 0.2782
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5594,
    style: {
      stopColor: "#7AE2D3",
      stopOpacity: 0.3982
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6515,
    style: {
      stopColor: "#62DDCB",
      stopOpacity: 0.5241
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7498,
    style: {
      stopColor: "#52DAC5",
      stopOpacity: 0.6586
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8588,
    style: {
      stopColor: "#48D8C2",
      stopOpacity: 0.8076
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9995,
    style: {
      stopColor: "#45D7C1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000069396818640610437160000013441522880268571063_)"
    },
    d: "M-18.52,455.21   c-5.11,0-10.07-2.46-14.7-5.17c-10.65-6.29-20.94-13.43-30.58-21.25c-16.5-13.24-32.08-28.37-47.16-43   c-28.48-27.63-57.92-56.21-94.05-72.35c-29.54-13.24-64.4-17.35-98.17-11.58c-26.37,4.5-51.61,14.86-72.99,29.96   c-13.61,9.61-25.95,21.5-37.88,33.01c-15.57,15.01-31.68,30.54-50.76,41.12c-1.87,1.04-3.17,0.6-3.94,0.05   c-5.19-3.74-1.49-28.4,9.34-85.96c1.43-7.58,2.86-15.61,4.37-24.11c2.05-11.5,4.17-23.38,6.62-36.18   c5.37-28,12.65-62.11,22.25-104.27c21.01-92.28,45.67-202.68,69.45-310.88c15.4-70.07,32.47-149.42,42.32-206.66   c4.9-28.46,7.73-49.66,8.68-64.81c1.28-20.61-1.33-24.99-3-25.77l1.19-2.57c5.19,2.41,9.41,15.23-4.08,93.63   c-9.86,57.29-26.94,136.69-42.35,206.79c-23.78,108.2-48.45,218.61-69.46,310.9c-9.59,42.13-16.87,76.21-22.23,104.18   c-2.45,12.78-4.57,24.66-6.62,36.14c-1.52,8.51-2.95,16.54-4.38,24.13c-4.78,25.39-8.34,45.21-10.21,59.4   c-2.59,19.72-1.04,23.16-0.26,23.73c0.2,0.14,0.74-0.14,0.91-0.23c18.76-10.4,34.73-25.79,50.17-40.68   c12.01-11.58,24.43-23.55,38.21-33.28c21.72-15.35,47.36-25.87,74.14-30.44c34.31-5.87,69.76-1.68,99.81,11.79   c36.58,16.35,66.21,45.1,94.87,72.9c15.03,14.58,30.57,29.66,46.96,42.83c9.54,7.73,19.71,14.8,30.23,21.01   c4.76,2.79,9.84,5.28,14.78,4.68c8.67-1.05,13.33-10.28,17.03-18.85c21.6-50.26,50.44-87.94,85.71-112   c43.83-29.9,97.85-36.69,140.99-17.72c29.46,13.06,53.25,36.98,76.25,60.12c6.6,6.63,13.42,13.49,20.25,19.97   c8.39,7.95,16.85,15.3,25.16,21.84c34.69,27.31,69.17,42.46,102.48,45.04c23.79,1.85,48.87-3.7,70.62-15.63   c22.77-12.49,40.05-30.66,49.96-52.53c6.54-14.42,10.38-30.43,14.09-45.9c6.93-28.89,13.48-56.18,36.08-73.99   c11.9-9.38,26.61-14,40.73-17.59c22.18-5.65,44.94-9.45,67.63-11.28c38.77-3.08,77.64-0.66,115.55,7.19   c6.36,1.31,12.88,2.78,19.18,4.2c33.09,7.47,67.3,15.18,96.58,4.05c5.04-1.91,9.92-4.33,14.53-7.2   c21.82-13.54,35.75-35.61,50.49-58.98c3.79-6.01,7.71-12.22,11.77-18.28c9.09-13.59,21.82-30.99,39.72-44.94   c12.71-9.92,28.07-17.94,45.67-23.83c39.05-13.09,83.29-13.92,121.38-2.27c3.4,1.04,6.85,2.18,10.26,3.41   c19.68,7.14,37.73,17.35,55.2,27.23c29.44,16.65,60.06,26.32,86.14,33.57c87.61,24.38,130.1,9.59,157.33-6.02   c11.09-6.36,20.89-16.6,30.36-26.49c13.26-13.85,26.96-28.17,44.5-32.11c172.29-39,264.79,65.7,326,134.99   c15.75,17.82,29.34,33.22,41.62,43.08l-1.78,2.21c-12.46-10.02-26.14-25.49-41.97-43.42c-60.77-68.79-152.6-172.73-323.25-134.1   c-16.7,3.75-29.51,17.13-43.07,31.3c-9.61,10.04-19.55,20.42-31,26.99c-23.54,13.49-49.76,19.85-80.14,19.46   c-30.18-0.4-59.75-7.7-79.37-13.16c-26.24-7.3-57.06-17.03-86.77-33.83c-17.36-9.82-35.32-19.97-54.77-27.03   c-3.35-1.21-6.76-2.34-10.12-3.37c-37.54-11.48-81.15-10.66-119.65,2.24c-17.29,5.79-32.38,13.66-44.83,23.38   c-17.58,13.7-30.13,30.86-39.11,44.28c-4.04,6.03-7.95,12.23-11.73,18.22c-14.92,23.65-29.01,45.99-51.39,59.88   c-4.76,2.97-9.82,5.48-15.02,7.45c-30.08,11.44-64.71,3.62-98.21-3.93c-6.29-1.42-12.8-2.89-19.13-4.19   c-37.65-7.8-76.26-10.2-114.75-7.14c-22.53,1.82-45.13,5.59-67.16,11.21c-13.82,3.52-28.18,8.02-39.67,17.07   c-21.82,17.2-28.26,44.03-35.07,72.43c-3.74,15.61-7.62,31.75-14.27,46.41c-10.16,22.43-27.86,41.05-51.17,53.84   c-22.22,12.19-47.86,17.86-72.2,15.97c-33.88-2.63-68.88-17.98-104.01-45.64c-8.38-6.6-16.91-14-25.36-22.01   c-6.86-6.5-13.69-13.38-20.31-20.02c-22.82-22.95-46.41-46.68-75.39-59.52c-42.24-18.58-95.22-11.89-138.25,17.47   c-34.82,23.75-63.32,61.03-84.7,110.78c-4.01,9.3-9.14,19.31-19.29,20.54C-17.29,455.17-17.91,455.21-18.52,455.21z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023972938833230262560000003624884442243979660_",
    gradientUnits: "userSpaceOnUse",
    x1: -493.8126,
    y1: 3.5913,
    x2: 1988.6392,
    y2: 3.5913
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2681,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3068,
    style: {
      stopColor: "#E8FAF7",
      stopOpacity: 0.0528
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3871,
    style: {
      stopColor: "#BDF1E9",
      stopOpacity: 0.1627
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4716,
    style: {
      stopColor: "#98E9DD",
      stopOpacity: 0.2782
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5594,
    style: {
      stopColor: "#7AE2D3",
      stopOpacity: 0.3982
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6515,
    style: {
      stopColor: "#62DDCB",
      stopOpacity: 0.5241
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7498,
    style: {
      stopColor: "#52DAC5",
      stopOpacity: 0.6586
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8588,
    style: {
      stopColor: "#48D8C2",
      stopOpacity: 0.8076
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9995,
    style: {
      stopColor: "#45D7C1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000023972938833230262560000003624884442243979660_)"
    },
    d: "M-41.2,467.67   c-5.04,0-9.95-2.37-14.55-5.01c-10.77-6.25-21.14-13.41-30.84-21.3c-17.16-13.79-33.25-29.75-48.81-45.18   c-27.92-27.69-56.79-56.31-92.34-72.69c-29.69-13.69-64.73-17.98-98.67-12.1c-26.58,4.6-51.91,15.22-73.25,30.74   c-13.81,10.03-26.29,22.4-38.37,34.36c-15.37,15.23-31.27,30.97-50.05,42.05c-1.82,1.07-3.08,0.52-3.66,0.1   c-4.64-3.34-1.83-24.12,12.02-88.93c1.36-6.38,2.76-13.07,4.22-20.04c2.78-13.26,5.65-26.96,8.94-41.84   c6.38-28.88,14.54-63.37,24.95-105.45c20.22-81.81,50.21-203.36,76.97-313.99c17.22-71.19,36.43-152.03,48.32-211.81   c14.66-73.71,13.41-92.2,9.78-94.73l1.62-2.33c4.41,3.08,7.42,16.95-8.62,97.61c-11.9,59.83-31.12,140.7-48.34,211.92   c-26.76,110.63-56.75,232.19-76.97,314c-10.41,42.06-18.56,76.53-24.94,105.39c-3.28,14.86-6.15,28.56-8.93,41.81   c-1.46,6.98-2.86,13.67-4.23,20.05c-6.42,30.05-10.04,48.59-12.11,61.99c-3.3,21.41-1.44,23.78-1.03,24.04   c0-0.01,0.18-0.01,0.57-0.24c18.48-10.9,34.24-26.52,49.49-41.62c12.15-12.04,24.71-24.48,38.69-34.64   c21.69-15.77,47.43-26.57,74.43-31.24c34.5-5.99,70.14-1.61,100.34,12.32c36,16.59,65.05,45.39,93.15,73.25   c15.51,15.38,31.55,31.29,48.6,44.99c9.59,7.8,19.84,14.89,30.48,21.05c4.83,2.76,9.98,5.22,14.96,4.5   c8.88-1.28,13.5-11.09,17.12-20.19c21.32-53.5,50.37-93.89,86.33-120.02c20.79-15.11,44.73-25.33,69.22-29.57   c26.16-4.52,51.86-1.87,74.32,7.67c30.05,12.83,54.1,37.04,77.37,60.45c6.52,6.56,13.27,13.35,20.02,19.75   c8.41,7.98,16.93,15.37,25.32,21.97c34.78,27.31,69.5,42.51,103.2,45.17c51.23,4.06,102.24-24.96,121.27-69   c6.4-14.81,9.85-31.37,13.19-47.39c6.08-29.21,11.83-56.8,33.93-74.93c11.68-9.58,26.34-14.37,40.46-18.12   c22.1-5.88,44.77-9.98,67.4-12.19c38.76-3.75,77.75-2.15,115.88,4.77c6.12,1.1,12.4,2.35,18.47,3.56   c33.81,6.72,68.76,13.68,98.81,0.79c5.12-2.22,10.07-4.97,14.71-8.18c22.26-15.21,36.24-39.31,51.03-64.83   c3.67-6.34,7.47-12.89,11.39-19.27c9.01-14.68,21.59-33.42,39.14-48.09c12.74-10.64,27.99-19.04,45.34-24.97   c37.65-12.83,81.82-13.08,121.2-0.67c3.62,1.15,6.95,2.29,10.2,3.48c19.3,7.07,37.15,16.67,55.26,26.72   c26.95,14.94,55.5,27.49,87.28,38.36c42.24,14.44,104.8,30.18,160.23,0.37c11.31-6.09,21.26-16.18,30.88-25.95   c13.45-13.65,27.36-27.76,45.24-31.1c171.56-32.25,264.87,78.97,326.62,152.58c17.85,21.28,33.27,39.65,47.18,50.59l-1.75,2.23   c-14.15-11.12-29.65-29.6-47.6-51c-30.98-36.92-69.53-82.88-121.56-115.55c-61.12-38.38-127.32-50.17-202.37-36.07   c-17.01,3.18-29.99,16.35-43.74,30.31c-9.77,9.91-19.87,20.16-31.56,26.45c-23.56,12.67-48.33,17.27-72.3,17.28   c-33.43,0-65.3-8.95-90.19-17.46c-31.94-10.92-60.64-23.54-87.74-38.56c-18.01-9.99-35.75-19.53-54.86-26.53   c-3.21-1.18-6.5-2.3-10.07-3.44c-38.81-12.23-82.34-11.99-119.43,0.65c-17.02,5.82-31.97,14.05-44.44,24.46   c-17.23,14.41-29.65,32.9-38.54,47.4c-3.9,6.35-7.69,12.88-11.36,19.21c-14.96,25.81-29.09,50.18-51.88,65.75   c-4.79,3.31-9.9,6.15-15.2,8.45c-30.86,13.23-66.26,6.2-100.49-0.61c-6.06-1.21-12.33-2.45-18.42-3.55   c-37.88-6.87-76.61-8.46-115.11-4.73c-22.47,2.2-45,6.27-66.94,12.11c-13.8,3.67-28.13,8.34-39.39,17.58   c-21.33,17.49-26.98,44.61-32.96,73.31c-3.36,16.16-6.84,32.86-13.36,47.94c-18.28,42.3-65.31,71.09-114.31,71.09   c-3.26,0-6.52-0.13-9.78-0.38c-34.26-2.71-69.5-18.11-104.72-45.77c-8.47-6.65-17.05-14.1-25.52-22.14   c-6.78-6.43-13.54-13.23-20.08-19.81c-23.08-23.22-46.94-47.23-76.47-59.84c-21.95-9.33-47.1-11.92-72.73-7.49   c-24.07,4.16-47.6,14.21-68.04,29.07C30.22,352.59,1.5,392.56-19.62,445.56c-2.83,7.11-8.1,20.33-19.35,21.95   C-39.72,467.62-40.46,467.67-41.2,467.67z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000148642497537928147870000006916379353329408909_",
    gradientUnits: "userSpaceOnUse",
    x1: -516.6104,
    y1: 7.0688,
    x2: 1981.0474,
    y2: 7.0688
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2681,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3068,
    style: {
      stopColor: "#E8FAF7",
      stopOpacity: 0.0528
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3871,
    style: {
      stopColor: "#BDF1E9",
      stopOpacity: 0.1627
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4716,
    style: {
      stopColor: "#98E9DD",
      stopOpacity: 0.2782
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5594,
    style: {
      stopColor: "#7AE2D3",
      stopOpacity: 0.3982
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6515,
    style: {
      stopColor: "#62DDCB",
      stopOpacity: 0.5241
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7498,
    style: {
      stopColor: "#52DAC5",
      stopOpacity: 0.6586
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8588,
    style: {
      stopColor: "#48D8C2",
      stopOpacity: 0.8076
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9995,
    style: {
      stopColor: "#45D7C1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000148642497537928147870000006916379353329408909_)"
    },
    d: "M-63.92,480c-4.97,0-9.84-2.28-14.4-4.82   c-10.89-6.22-21.36-13.4-31.11-21.36c-17.74-14.28-34.26-31.02-50.23-47.2c-27.44-27.8-55.81-56.54-90.87-73.16   c-29.75-14.11-64.97-18.6-99.17-12.62c-26.77,4.68-52.19,15.57-73.52,31.5c-14.04,10.49-26.71,23.37-38.97,35.82   c-15.14,15.39-30.8,31.29-49.19,42.87c-1.68,1.06-2.87,0.55-3.42,0.16c-3.85-2.75-2.68-18.67,14.72-91.89l0.7-2.93   c4.28-18.01,9.13-38.42,14.65-60.54c7.92-31.82,17.22-67.73,27.66-106.71c11.23-42.36,23.02-86.43,35.51-133.09   c16.39-61.25,33.34-124.59,48.98-184.01c26.52-100.71,43.28-167.62,54.33-216.94c17.06-76.07,16.97-95.8,13.9-98.95l2.03-1.98   c9.28,9.51-9.65,98.83-67.52,318.59c-15.65,59.43-32.6,122.77-48.99,184.02c-12.48,46.66-24.28,90.73-35.51,133.09   c-10.44,38.97-19.74,74.86-27.65,106.66c-5.52,22.11-10.36,42.51-14.64,60.51l-0.7,2.93c-6.89,29.02-11.29,49.2-13.85,63.53   c-3.69,20.7-2.6,24.6-2.05,25.32c0.07-0.03,0.18-0.08,0.33-0.17c18.11-11.4,33.65-27.19,48.68-42.46   c12.33-12.53,25.08-25.49,39.3-36.1c21.68-16.19,47.52-27.27,74.72-32.02c34.77-6.07,70.59-1.51,100.87,12.85   c35.52,16.83,64.07,45.76,91.68,73.73c15.92,16.13,32.38,32.81,50,46.99c9.64,7.87,19.97,14.96,30.72,21.09   c4.56,2.54,9.88,5.19,15.15,4.28c8.65-1.49,13.39-11.27,17.22-21.61c20.99-56.62,50.24-99.69,86.95-128.02   c21.03-16.23,45.39-27.42,70.45-32.37c26.61-5.25,52.77-3.08,75.66,6.3c30.61,12.59,54.92,37.07,78.43,60.74   c6.47,6.51,13.15,13.25,19.84,19.6c8.43,8,17,15.44,25.49,22.09c34.9,27.32,69.86,42.56,103.92,45.3   c52.28,4.2,103.58-25.17,121.95-69.84c6.25-15.19,9.29-32.3,12.24-48.84c5.26-29.55,10.22-57.46,31.84-75.91   c11.47-9.78,26.09-14.74,40.18-18.65c22.01-6.11,44.61-10.51,67.18-13.09c38.77-4.43,77.88-3.64,116.25,2.34   c5.91,0.92,11.98,1.97,17.85,2.99c34.49,5.97,70.16,12.14,100.92-2.53c5.23-2.5,10.27-5.55,14.96-9.06   c22.8-16.99,36.83-43.18,51.7-70.91c3.53-6.58,7.17-13.39,10.92-20c9.47-16.75,21.46-35.94,38.56-51.24   c12.64-11.3,27.79-20.08,45.01-26.07c36.16-12.62,80.24-12.28,120.93,0.92c3.36,1.09,6.78,2.28,10.14,3.52   c19.63,7.28,38.19,16.9,55.31,26.21c27.4,14.92,57.08,30.46,88.43,43.15c29.32,11.86,56.75,18.94,81.51,21.03   c30.36,2.56,57.82-2.24,81.59-14.27c11.57-5.79,21.7-15.76,31.5-25.42c13.62-13.42,27.71-27.3,45.89-30.04   c75.69-11.44,142.55,3.5,204.38,45.66c52.55,35.83,91.75,84.96,123.26,124.44c19.8,24.81,36.9,46.24,52.38,58.15l-1.73,2.25   c-15.75-12.13-32.95-33.68-52.86-58.63c-31.38-39.33-70.44-88.27-122.64-123.86c-61.21-41.74-127.4-56.52-202.36-45.19   c-17.28,2.6-30.42,15.55-44.33,29.25c-9.95,9.81-20.24,19.94-32.21,25.93c-24.25,12.27-52.21,17.17-83.11,14.57   c-25.05-2.11-52.75-9.25-82.34-21.22c-31.48-12.74-61.24-28.33-88.72-43.28c-17.03-9.26-35.48-18.83-54.94-26.04   c-3.33-1.23-6.7-2.41-10.03-3.49c-40.11-13.01-83.53-13.36-119.12-0.94c-16.87,5.88-31.69,14.46-44.05,25.51   c-16.79,15.04-28.62,33.98-37.98,50.53c-3.73,6.59-7.37,13.38-10.89,19.95c-15.01,28.02-29.2,54.48-52.5,71.85   c-4.84,3.62-10.03,6.76-15.43,9.34c-31.58,15.06-67.7,8.81-102.63,2.76c-5.86-1.01-11.92-2.06-17.81-2.98   c-38.12-5.94-76.97-6.72-115.49-2.32c-22.42,2.56-44.88,6.94-66.75,13.01c-13.78,3.82-28.05,8.65-39.1,18.07   c-20.84,17.8-25.72,45.22-30.89,74.25c-2.97,16.69-6.04,33.95-12.4,49.42c-18.83,45.78-71.31,75.89-124.8,71.59   c-34.63-2.78-70.1-18.22-105.44-45.89c-8.55-6.71-17.2-14.2-25.69-22.26c-6.72-6.38-13.42-13.13-19.9-19.66   c-23.31-23.47-47.41-47.74-77.49-60.12c-22.37-9.16-47.97-11.28-74.03-6.14c-24.63,4.86-48.59,15.87-69.27,31.83   c-36.28,28-65.22,70.64-86.02,126.76c-4.12,11.14-9.33,21.69-19.39,23.42C-62.18,479.93-63.05,480-63.92,480z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008832861992703990510000013813609907241349778_",
    gradientUnits: "userSpaceOnUse",
    x1: -539.4249,
    y1: 10.7488,
    x2: 1973.4761,
    y2: 10.7488
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2681,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3068,
    style: {
      stopColor: "#E8FAF7",
      stopOpacity: 0.0528
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3871,
    style: {
      stopColor: "#BDF1E9",
      stopOpacity: 0.1627
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4716,
    style: {
      stopColor: "#98E9DD",
      stopOpacity: 0.2782
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5594,
    style: {
      stopColor: "#7AE2D3",
      stopOpacity: 0.3982
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6515,
    style: {
      stopColor: "#62DDCB",
      stopOpacity: 0.5241
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7498,
    style: {
      stopColor: "#52DAC5",
      stopOpacity: 0.6586
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8588,
    style: {
      stopColor: "#48D8C2",
      stopOpacity: 0.8076
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9995,
    style: {
      stopColor: "#45D7C1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000008832861992703990510000013813609907241349778_)"
    },
    d: "M-86.66,492.52   c-4.95,0-9.75-2.22-14.25-4.71c-31.67-17.49-57.72-44.46-82.91-70.55c-26.98-27.94-54.88-56.82-89.5-73.68   c-26.84-13.07-57.48-18.16-88.61-14.73c-31.12,3.43-60.46,15.14-84.85,33.85c-14.32,11-27.23,24.43-39.72,37.42   c-14.88,15.48-30.27,31.48-48.2,43.55c-1.58,1.06-2.7,0.57-3.23,0.19c-3.6-2.62-2.84-20.2,26.85-130.12   c20.31-75.18,48.89-174.23,79.16-279.1c34-117.81,69.16-239.64,94.48-334.39c28.16-105.39,40.02-162.48,35.27-169.71l2.37-1.56   c6.97,10.59-14.99,97.48-34.9,172c-25.32,94.78-60.48,216.61-94.49,334.44c-30.03,104.04-58.39,202.3-78.66,277.26   c-10.87,40.18-18.44,70.06-23.14,91.36c-6.56,29.71-5.94,36.01-5.36,37.33c0.02-0.01,0.05-0.03,0.08-0.05   c17.67-11.9,32.96-27.79,47.74-43.16c12.56-13.06,25.55-26.57,40.04-37.7c24.8-19.02,54.63-30.92,86.27-34.42   c31.66-3.5,62.84,1.69,90.16,15c35.07,17.08,63.15,46.15,90.3,74.26c25.05,25.93,50.95,52.75,82.24,70.04   c4.94,2.73,10.23,5.12,15.35,4.12c8.85-1.73,13.56-12.07,17.34-22.99c20.73-59.92,50.2-105.7,87.58-136.06   c21.33-17.32,46.12-29.47,71.7-35.15c27.07-6.01,53.68-4.31,76.96,4.9c31.18,12.35,55.74,37.1,79.5,61.03   c6.41,6.46,13.04,13.14,19.67,19.44c43.5,41.36,87.33,64.11,130.27,67.61c24.74,2.02,50.57-3.56,72.73-15.7   c23.64-12.96,40.9-31.98,49.91-54.99c6.09-15.55,8.7-33.2,11.23-50.27c4.24-28.59,8.62-58.16,29.8-76.92   c11.79-10.44,26.78-15.37,39.91-19.17c60.27-17.39,122.02-22.13,183.56-14.09c5.71,0.75,11.59,1.62,17.27,2.46   c35.17,5.2,71.55,10.58,103.01-5.88c32.68-17.09,49.58-51.07,67.47-87.05c13.41-26.96,27.27-54.84,48.44-75.09   c20.52-19.62,46.93-31.37,78.51-34.9c27.63-3.09,57.69,0.43,86.9,10.19c33.66,11.24,65.27,28.92,95.84,46.01   c19.19,10.73,39.03,21.82,59.18,31.21c44.44,20.71,109.32,39.81,166.02,13.13c11.75-5.52,22-15.34,31.92-24.83   c13.84-13.25,28.15-26.95,46.75-29.09c75.75-8.75,142.69,9.14,204.65,54.69c52.73,38.76,92.39,90.92,124.27,132.83   c21.62,28.43,40.29,52.99,57.29,65.81l-1.71,2.26c-17.31-13.06-36.09-37.76-57.84-66.36c-31.76-41.77-71.29-93.74-123.69-132.27   c-61.35-45.1-127.64-62.82-202.64-54.15c-17.65,2.03-30.99,14.8-45.11,28.32c-10.08,9.65-20.5,19.63-32.67,25.35   c-20.3,9.55-41.6,13.35-62.64,13.35c-38.75,0-76.62-12.89-105.79-26.48c-20.24-9.43-40.13-20.55-59.36-31.3   c-30.46-17.03-61.95-34.63-95.36-45.79c-28.83-9.63-58.46-13.1-85.69-10.06c-30.95,3.46-56.81,14.95-76.86,34.13   c-20.81,19.91-34.56,47.56-47.86,74.3c-17.3,34.8-35.2,70.78-68.69,88.3c-32.28,16.88-69.11,11.44-104.74,6.17   c-5.67-0.84-11.53-1.71-17.22-2.45c-61.14-7.99-122.51-3.28-182.4,14c-12.83,3.71-27.47,8.52-38.82,18.56   c-20.41,18.07-24.52,45.83-28.88,75.21c-2.55,17.22-5.19,35.03-11.4,50.88c-19.17,48.98-70.86,72.88-115.63,72.88   c-3.34,0-6.63-0.13-9.88-0.4c-43.61-3.56-88.02-26.57-131.99-68.39c-6.66-6.33-13.3-13.02-19.73-19.5   c-23.55-23.73-47.9-48.26-78.53-60.39c-22.75-9.01-48.78-10.66-75.3-4.77c-25.15,5.58-49.53,17.54-70.52,34.58   c-36.97,30.02-66.13,75.36-86.69,134.78c-4.05,11.72-9.22,22.85-19.47,24.85C-84.65,492.43-85.66,492.52-86.66,492.52z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st15"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000001663665377266376930000007677136106366842254_",
    gradientUnits: "userSpaceOnUse",
    x1: -350.8423,
    y1: 89.0093,
    x2: 2133.4546,
    y2: 89.0093
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2681,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3068,
    style: {
      stopColor: "#E8FAF7",
      stopOpacity: 0.0528
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3871,
    style: {
      stopColor: "#BDF1E9",
      stopOpacity: 0.1627
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4716,
    style: {
      stopColor: "#98E9DD",
      stopOpacity: 0.2782
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5594,
    style: {
      stopColor: "#7AE2D3",
      stopOpacity: 0.3982
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6515,
    style: {
      stopColor: "#62DDCB",
      stopOpacity: 0.5241
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7498,
    style: {
      stopColor: "#52DAC5",
      stopOpacity: 0.6586
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8588,
    style: {
      stopColor: "#48D8C2",
      stopOpacity: 0.8076
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9995,
    style: {
      stopColor: "#45D7C1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "url(#SVGID_00000001663665377266376930000007677136106366842254_)"
    },
    d: "M1660.13,540.54   c-2.71,0-5.24-0.92-7.63-2.89c-2.92-2.4-5.87-4.91-8.72-7.34c-13.5-11.51-27.46-23.41-44.47-28.52c-3.56-1.07-7.23-1.89-10.91-2.44   c-26.49-3.96-52.32,5.88-79.67,16.31c-14.5,5.53-29.49,11.24-44.54,14.67c-17.18,3.79-34.71,5.05-52.11,3.74   c-18.35-1.33-35.71-5.49-50.19-12.04c-20.99-9.5-35.33-22.67-51.94-37.92c-2.76-2.54-5.6-5.14-8.56-7.82   c-3.53-3.19-7.23-6.44-10.7-9.46c-7.9-6.96-16.26-14.76-25.11-23.01c-19.28-17.97-41.13-38.35-64.19-55.51   c-33.88-25.32-70.17-42.31-107.86-50.52c-23.26-4.92-47.13-6.6-70.95-4.98c-17.32,1.11-31.99,3.73-44.84,7.99   c-42.58,14.16-72.29,43.88-103.74,75.35c-25.79,25.79-65.9,56.07-110.43,53.79c-36.82-1.84-68.08-24.15-91.2-43.39   c-7.61-6.32-15.14-12.98-22.37-19.79c-10.78-10.1-21.39-20.84-31.64-31.22c-15.68-15.87-31.89-32.28-48.68-46.33   c-32.18-26.93-65.83-43.32-92.86-56.49l-0.75-0.36c-5.14-2.5-10.05-4.94-14.8-7.29c-21.34-10.56-39.77-19.68-58.59-25.35   c-1.11-0.34-2.27-0.63-3.5-0.94c-3.77-0.96-8.04-2.05-13.42-4.87c-4.16-2.18-8.42-5.6-12.09-8.64   c-7.63-6.28-16.66-13.66-25.8-20.71c-50.25-38.82-95.4-61.19-142.08-70.41c-27.57-5.51-58.41-6.27-89.18-2.2   c-23.1,3.11-46.09,8.53-68.33,16.13c-11.37,3.86-22.51,8.49-33.29,12.97c-18.98,7.88-38.6,16.04-59.4,19.87   c-18.26,3.36-33.8-7.31-47.51-32.64c-11.11-8.85-20.56-19.58-28.12-31.88c-13.73-22-20.93-52.67-26.66-82.54   c-14.49-75.47-35.07-172.61-65.8-254.65c-28.03-74.77-61.85-122.9-95.23-135.5c-14.06-5.31-28.11-4.32-41.76,2.96l-1.33-2.5   c14.4-7.68,29.24-8.73,44.1-3.11c34.15,12.9,68.56,61.61,96.88,137.16c30.81,82.24,51.42,179.53,65.93,255.11   c5.68,29.6,12.8,59.97,26.29,81.59c7.44,12.11,16.75,22.65,27.7,31.33l0.23,0.18l0.14,0.26c13.08,24.29,27.67,34.58,44.63,31.45   c20.5-3.78,39.12-11.51,58.83-19.7c10.82-4.5,22.01-9.14,33.46-13.03c22.4-7.66,45.58-13.12,68.86-16.26   c31.08-4.1,62.24-3.33,90.11,2.23c47.13,9.31,92.66,31.86,143.27,70.95c9.18,7.08,18.23,14.48,25.88,20.77   c3.56,2.95,7.69,6.27,11.6,8.32c5.09,2.67,9.19,3.71,12.81,4.63c1.26,0.32,2.45,0.62,3.62,0.98c19.06,5.73,37.58,14.9,59.03,25.52   c4.74,2.35,9.66,4.78,14.79,7.28l0.75,0.36c27.17,13.24,60.99,29.71,93.44,56.86c16.89,14.13,33.15,30.59,48.87,46.51   c10.24,10.37,20.82,21.08,31.57,31.15c7.2,6.77,14.68,13.39,22.25,19.68c22.78,18.96,53.54,40.95,89.53,42.74   c43.49,2.2,82.89-27.58,108.28-52.97c31.7-31.71,61.64-61.67,104.85-76.04c13.09-4.34,27.99-7,45.55-8.12   c24.07-1.63,48.21,0.06,71.73,5.04c38.09,8.29,74.75,25.45,108.96,51.01c23.19,17.26,45.1,37.69,64.43,55.71   c8.84,8.24,17.18,16.02,25.05,22.95c3.48,3.03,7.18,6.29,10.73,9.49c2.97,2.68,5.81,5.29,8.58,7.83   c17.1,15.71,30.61,28.11,51.19,37.42c14.18,6.41,31.2,10.49,49.23,11.79c17.13,1.3,34.38,0.06,51.28-3.68   c14.85-3.38,29.75-9.06,44.16-14.56c26.49-10.1,53.88-20.54,81.1-16.46c3.81,0.57,7.62,1.42,11.31,2.52   c17.58,5.28,31.77,17.38,45.49,29.08c2.84,2.42,5.78,4.93,8.68,7.31c10.09,8.28,25.81-8.81,49.6-34.67   c5.02-5.45,10.2-11.09,15.89-17.11c5.91-6.25,12.35-12.77,19.17-19.66c25.49-25.78,57.22-57.87,86.24-102.06   c7.35-11.2,14.45-24.09,21.31-36.56c9.6-17.45,19.53-35.49,30.66-49.94C2015.5,94.67,2096.33-3.95,2124.48-3.95   c0.4,0,0.79,0.02,1.17,0.06c3.51,0.37,6.13,2.34,7.8,5.87l-2.56,1.22c-1.24-2.61-3.05-4-5.54-4.26c-0.31-0.03-0.63-0.05-0.96-0.05   c-29.57,0-132.73,131.6-244.97,278.31c-11,14.28-20.88,32.22-30.43,49.58c-6.89,12.52-14.01,25.46-21.42,36.75   c-29.18,44.42-61.01,76.62-86.6,102.49c-6.81,6.88-13.24,13.39-19.13,19.62c-5.67,6-10.85,11.64-15.86,17.08   C1685.28,525.2,1671.18,540.54,1660.13,540.54z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000157309909719068466540000009992053671821246636_",
    gradientUnits: "userSpaceOnUse",
    x1: -348.4487,
    y1: 75.5247,
    x2: 2125.853,
    y2: 75.5247
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2681,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3068,
    style: {
      stopColor: "#E8FAF7",
      stopOpacity: 0.0528
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3871,
    style: {
      stopColor: "#BDF1E9",
      stopOpacity: 0.1627
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4716,
    style: {
      stopColor: "#98E9DD",
      stopOpacity: 0.2782
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5594,
    style: {
      stopColor: "#7AE2D3",
      stopOpacity: 0.3982
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6515,
    style: {
      stopColor: "#62DDCB",
      stopOpacity: 0.5241
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7498,
    style: {
      stopColor: "#52DAC5",
      stopOpacity: 0.6586
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8588,
    style: {
      stopColor: "#48D8C2",
      stopOpacity: 0.8076
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9995,
    style: {
      stopColor: "#45D7C1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "url(#SVGID_00000157309909719068466540000009992053671821246636_)"
    },
    d: "M1641.78,517.97   c-2.95,0-5.71-0.96-8.3-3.04c-3.03-2.42-6.08-4.97-9.03-7.43c-13.48-11.23-27.42-22.83-44.25-27.95   c-3.56-1.08-7.21-1.92-10.87-2.49c-26.98-4.26-53.38,5.42-81.33,15.67c-13.9,5.1-28.26,10.37-42.63,13.71   c-16.02,3.75-33.41,5.38-51.7,4.85c-18.11-0.59-35.26-3.66-49.6-8.87c-21.92-7.97-36.44-19.55-54.82-34.22   c-1.9-1.52-3.85-3.07-5.85-4.66c-2.19-1.74-4.49-3.52-6.86-5.37c-1.33-1.04-2.69-2.09-4.08-3.17   c-10.14-7.93-21.06-17.4-32.62-27.41c-17.63-15.28-37.62-32.6-58.25-47.23c-34.24-24.39-70.66-40.56-108.24-48.09   c-23.22-4.53-47-5.89-70.69-4.04c-17.41,1.28-31.98,4.06-44.55,8.49c-39.86,14.08-67.16,42.64-96.06,72.89l-4.66,4.87   c-19.9,20.79-59.61,54.81-106.17,54.82c-1.65,0-3.31-0.04-4.98-0.13c-37.7-1.96-70.51-25.77-91.9-43.52   c-7.36-6.11-14.95-12.81-22.56-19.92c-10.21-9.57-20.27-19.74-29.99-29.56c-16.42-16.59-33.41-33.75-51.18-48.1   c-31.25-25.21-64.63-40.22-96.06-52.68c-28.63-11.36-51.24-20.33-74-24.64c-0.98-0.19-2.01-0.34-3.1-0.5   c-3.88-0.57-8.28-1.21-14-3.91c-4.15-1.98-8.21-5.13-12.34-8.46l-2.75-2.22c-7.57-6.1-15.41-12.41-23.29-18.54   c-35.43-27.43-83.61-60.51-142.06-72.91c-27.71-5.94-58.72-6.89-89.68-2.75c-23.25,3.18-46.32,8.86-68.58,16.9   c-11.56,4.16-22.86,9.19-33.79,14.06c-18.7,8.33-38.04,16.95-58.69,21.07c-17.55,3.5-32.55-8.48-44.61-35.62   c-9.99-9.11-18.48-20.05-25.92-33.42c-12.66-22.76-18.99-53.7-23.93-83.76c-18-109.28-36.53-191.19-58.31-257.78   c-26.07-79.72-57.79-130.74-89.33-143.66c-12.39-5.08-24.94-4.41-37.31,1.99l-1.3-2.52c13.14-6.79,26.49-7.5,39.69-2.09   c17.14,7.02,34.05,24.31,50.25,51.4c14.57,24.35,28.26,55.97,40.69,94c21.82,66.73,40.38,148.77,58.41,258.2   c4.91,29.8,11.16,60.46,23.61,82.84c7.35,13.2,15.71,23.96,25.57,32.91l0.22,0.2l0.12,0.27c11.63,26.32,25.23,37.53,41.58,34.26   c20.33-4.06,38.67-12.23,58.09-20.88c10.97-4.89,22.32-9.94,33.98-14.14c22.45-8.11,45.72-13.84,69.16-17.05   c31.28-4.18,62.63-3.22,90.65,2.79c59.01,12.52,107.53,45.83,143.21,73.45c7.9,6.14,15.75,12.46,23.33,18.57l2.75,2.22   c4,3.22,7.91,6.26,11.78,8.11c5.33,2.51,9.51,3.12,13.19,3.66c1.12,0.16,2.17,0.32,3.21,0.52c23.02,4.36,45.75,13.37,74.52,24.79   c31.63,12.54,65.26,27.66,96.8,53.11c17.9,14.44,34.94,31.66,51.42,48.31c9.71,9.81,19.75,19.95,29.92,29.49   c7.56,7.07,15.11,13.74,22.43,19.81c44.02,36.51,72.59,41.95,90.24,42.87c47.59,2.5,88.69-32.64,108.96-53.82l4.66-4.87   c29.14-30.5,56.66-59.3,97.17-73.6c12.81-4.52,27.62-7.34,45.28-8.64c23.94-1.87,47.98-0.49,71.46,4.09   c37.99,7.6,74.77,23.94,109.33,48.56c20.75,14.71,40.79,32.08,58.47,47.4c11.53,9.99,22.42,19.43,32.51,27.32   c1.38,1.08,2.74,2.13,4.07,3.17c2.38,1.85,4.68,3.64,6.88,5.38c2,1.59,3.95,3.14,5.85,4.66c18.18,14.51,32.54,25.96,54.02,33.77   c14.06,5.11,30.91,8.12,48.71,8.7c18.05,0.52,35.19-1.09,50.97-4.78c14.2-3.31,28.48-8.55,42.3-13.61   c27.06-9.93,55.04-20.19,82.74-15.81c3.78,0.59,7.57,1.46,11.25,2.58c17.38,5.28,31.55,17.07,45.25,28.48   c2.94,2.45,5.99,4.98,8.99,7.39c10.61,8.52,26.21-7.02,49.81-30.54c5.29-5.27,10.76-10.72,16.79-16.52   c6.12-5.9,12.78-12,19.84-18.47c26.21-24.01,58.82-53.89,88.45-96.79c7.55-10.94,14.8-23.67,21.81-35.99   c9.82-17.24,19.97-35.07,31.43-48.96C2015.08,81.5,2088.27,7.6,2116.1,10.33c4.32,0.43,7.6,2.67,9.76,6.68l-2.5,1.34   c-1.7-3.17-4.17-4.87-7.54-5.2c-33.11-3.24-139.82,120.2-250.25,254.11c-11.31,13.71-21.4,31.42-31.15,48.56   c-7.04,12.37-14.32,25.16-21.95,36.2c-29.81,43.16-62.55,73.16-88.87,97.27c-7.04,6.45-13.69,12.54-19.79,18.42   c-6.01,5.79-11.47,11.23-16.75,16.49C1667.47,503.71,1653.15,517.97,1641.78,517.97z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000119078280086608080030000015942804283921424292_",
    gradientUnits: "userSpaceOnUse",
    x1: -346.0317,
    y1: 62.0203,
    x2: 2118.2612,
    y2: 62.0203
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2681,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3068,
    style: {
      stopColor: "#E8FAF7",
      stopOpacity: 0.0528
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3871,
    style: {
      stopColor: "#BDF1E9",
      stopOpacity: 0.1627
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4716,
    style: {
      stopColor: "#98E9DD",
      stopOpacity: 0.2782
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5594,
    style: {
      stopColor: "#7AE2D3",
      stopOpacity: 0.3982
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6515,
    style: {
      stopColor: "#62DDCB",
      stopOpacity: 0.5241
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7498,
    style: {
      stopColor: "#52DAC5",
      stopOpacity: 0.6586
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8588,
    style: {
      stopColor: "#48D8C2",
      stopOpacity: 0.8076
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9995,
    style: {
      stopColor: "#45D7C1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "url(#SVGID_00000119078280086608080030000015942804283921424292_)"
    },
    d: "M1623.61,495.51   c-3.27,0-6.33-1.04-9.22-3.31c-3.09-2.42-6.22-4.97-9.24-7.43c-13.49-10.98-27.43-22.34-44.12-27.46   c-3.54-1.08-7.18-1.94-10.82-2.53c-27.55-4.58-54.62,4.97-83.28,15.07c-13.2,4.65-26.85,9.47-40.44,12.71   c-15.83,3.79-32.61,5.74-51.28,5.96c-18.14,0.15-34.62-1.78-48.94-5.69c-23.49-6.41-38.68-16.82-59.71-31.23l-1.14-0.78   c-1.54-1.06-3.12-2.13-4.75-3.23c-2.07-1.4-4.21-2.86-6.42-4.38c-12.07-8.32-25.19-18.93-39.09-30.15   c-17.04-13.77-34.66-28-53.34-40.61c-34.49-23.38-71.03-38.75-108.62-45.68c-23.19-4.16-46.9-5.23-70.48-3.17   c-17.56,1.48-32.03,4.43-44.26,9c-37.65,14.09-62.77,41.74-89.35,71.02c-2.75,3.03-5.53,6.09-8.34,9.16   c-16.18,17.66-59.47,58.43-111.88,55.57c-38.16-2.04-71.14-25.88-92.62-43.64c-7.53-6.21-14.95-12.76-22.71-20.04   c-9.74-9.14-19.35-18.84-28.65-28.22c-17.06-17.22-34.71-35.02-53.38-49.55c-33.98-26.45-70.5-39.83-98.52-48.52   c-30.73-9.54-52.78-15.31-74.56-16.64c-0.79-0.05-1.6-0.07-2.44-0.09c-3.86-0.1-8.66-0.24-14.87-2.9c-4.3-1.85-8.57-5.1-12.58-8.27   c-2.92-2.31-5.84-4.63-8.78-6.96c-5.72-4.54-11.64-9.24-17.56-13.83c-38.91-30.2-86.2-62.78-141.98-75.43   c-27.9-6.39-59.08-7.51-90.17-3.25c-23.4,3.23-46.57,9.17-68.85,17.67c-11.74,4.46-23.16,9.9-34.2,15.15   c-18.45,8.78-37.52,17.86-58.06,22.27c-17.1,3.68-31.13-9.31-41.71-38.6c-9.06-9.52-16.82-20.97-23.73-34.98   c-11.6-23.55-17.23-56.17-21.2-84.97c-14.66-106.26-31.27-191.61-50.79-260.91c-16.92-60.03-45.07-135.12-83.14-151.95   c-10.86-4.8-22.02-4.42-33.16,1.15l-1.27-2.54c11.93-5.96,23.9-6.37,35.57-1.2c39.07,17.28,67.64,93.16,84.72,153.77   c19.56,69.43,36.2,154.9,50.87,261.29c3.94,28.57,9.51,60.91,20.94,84.1c6.83,13.85,14.5,25.13,23.44,34.49l0.21,0.22l0.1,0.28   c10.03,27.94,23,40.42,38.55,37.07c20.21-4.34,38.29-12.95,57.43-22.06c11.09-5.28,22.56-10.74,34.41-15.24   c22.48-8.57,45.85-14.57,69.47-17.83c31.43-4.31,62.96-3.17,91.19,3.29c56.32,12.78,103.93,45.57,143.09,75.96   c5.93,4.6,11.85,9.31,17.58,13.85c2.93,2.33,5.85,4.65,8.77,6.95c3.86,3.05,7.97,6.18,11.95,7.89c5.71,2.45,10.02,2.57,13.82,2.67   c0.88,0.02,1.72,0.05,2.54,0.1c22.07,1.34,44.29,7.16,75.23,16.76c28.25,8.77,65.08,22.26,99.42,48.99   c18.82,14.64,36.53,32.51,53.65,49.79c9.28,9.36,18.87,19.04,28.57,28.14c7.71,7.23,15.09,13.75,22.57,19.92   c21.18,17.5,53.64,41.01,90.97,43c51.19,2.8,93.73-37.3,109.63-54.66c2.81-3.07,5.58-6.12,8.33-9.15   c26.82-29.54,52.16-57.44,90.46-71.77c12.47-4.67,27.2-7.67,45.01-9.17c23.82-2.08,47.79-1,71.23,3.21   c37.98,7,74.89,22.52,109.7,46.12c18.78,12.68,36.45,26.95,53.53,40.75c13.85,11.19,26.94,21.77,38.92,30.03   c2.2,1.52,4.34,2.97,6.4,4.37c1.63,1.11,3.22,2.19,4.76,3.24l1.14,0.78c20.8,14.25,35.82,24.55,58.85,30.84   c13.88,3.79,30.55,5.72,48.17,5.59c18.45-0.22,35.02-2.14,50.65-5.88c13.45-3.21,27.03-8,40.16-12.63   c27.73-9.78,56.41-19.89,84.69-15.2c3.77,0.62,7.54,1.5,11.19,2.62c17.22,5.29,31.38,16.82,45.08,27.97   c3.01,2.45,6.12,4.98,9.2,7.39c11.18,8.76,26.75-5.36,50.31-26.75c5.49-4.98,11.16-10.13,17.43-15.6   c6.27-5.47,13.07-11.08,20.26-17.02c27-22.28,60.61-50,90.97-91.78c7.75-10.67,15.14-23.24,22.29-35.4   c10.03-17.05,20.4-34.68,32.21-48.01c142.43-160.71,223.91-234.15,256.35-231.1c5.4,0.51,9.54,3.11,12.29,7.72l-2.43,1.45   c-2.3-3.85-5.61-5.93-10.12-6.35c-31.06-2.94-114.13,72.37-253.97,230.16c-11.63,13.13-21.93,30.64-31.89,47.57   c-7.19,12.22-14.62,24.85-22.44,35.62c-30.57,42.07-64.33,69.92-91.46,92.3c-7.18,5.93-13.97,11.52-20.21,16.97   c-6.25,5.45-11.91,10.59-17.39,15.56C1649.19,482.72,1635.09,495.51,1623.61,495.51z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000139270912611902364220000015874013210473846674_",
    gradientUnits: "userSpaceOnUse",
    x1: -343.6289,
    y1: 48.4853,
    x2: 2110.6411,
    y2: 48.4853
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2681,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3068,
    style: {
      stopColor: "#E8FAF7",
      stopOpacity: 0.0528
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3871,
    style: {
      stopColor: "#BDF1E9",
      stopOpacity: 0.1627
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4716,
    style: {
      stopColor: "#98E9DD",
      stopOpacity: 0.2782
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5594,
    style: {
      stopColor: "#7AE2D3",
      stopOpacity: 0.3982
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6515,
    style: {
      stopColor: "#62DDCB",
      stopOpacity: 0.5241
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7498,
    style: {
      stopColor: "#52DAC5",
      stopOpacity: 0.6586
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8588,
    style: {
      stopColor: "#48D8C2",
      stopOpacity: 0.8076
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9995,
    style: {
      stopColor: "#45D7C1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "url(#SVGID_00000139270912611902364220000015874013210473846674_)"
    },
    d: "M1605.62,473.07   c-3.63,0-7.03-1.13-10.27-3.61c-3.15-2.41-6.32-4.94-9.39-7.38c-13.51-10.75-27.48-21.88-44.07-27.02   c-3.52-1.09-7.14-1.96-10.77-2.59c-28.21-4.92-56.02,4.52-85.46,14.51c-12.42,4.22-25.26,8.57-38,11.68   c-15.5,3.79-32.14,6.1-50.88,7.07c-18.24,0.93-34.5,0.08-48.33-2.52c-24.38-4.58-39.98-12.91-61-25.11l-2.37-1.38   c-2.89-1.68-5.89-3.41-9.04-5.32c-13.75-8.28-28.85-19.68-44.84-31.74c-15.78-11.9-32.09-24.21-49.14-35.14   c-34.75-22.4-71.42-36.95-108.99-43.27c-23.16-3.79-46.81-4.56-70.28-2.28c-17.56,1.65-31.95,4.76-43.98,9.51   c-35.68,14.12-58.83,41.03-83.33,69.51c-3.68,4.27-7.48,8.69-11.33,13.08c-31.4,35.75-71.19,56.6-107.46,56.61   c-1.72,0-3.43-0.05-5.14-0.14c-38.61-2.13-71.76-26-93.33-43.77c-7.77-6.43-15.46-13.21-22.86-20.16   c-9.35-8.78-18.58-18.09-27.52-27.09c-17.63-17.77-35.86-36.15-55.36-50.79c-27.5-20.65-60.53-35.16-100.98-44.35   c-32.8-7.46-54.57-9.97-75.14-8.66c-0.67,0.04-1.36,0.1-2.07,0.17c-3.95,0.36-8.87,0.8-15.43-1.71c-4.44-1.72-8.96-5.07-12.84-8.08   c-4.83-3.74-9.75-7.61-14.51-11.35c-4.01-3.15-8.03-6.31-12.09-9.47c-39.39-30.64-86.09-64.46-141.93-77.9   c-28.04-6.82-59.39-8.12-90.67-3.77c-23.55,3.3-46.8,9.51-69.1,18.44c-11.89,4.76-23.4,10.59-34.53,16.23   c-18.22,9.23-37.06,18.78-57.51,23.49c-1.79,0.41-3.55,0.62-5.26,0.62c-14.17,0-25.43-14.16-33.54-42.21   c-8.13-9.88-15.18-21.84-21.54-36.56c-10.5-24.32-15.23-57.2-18.47-86.16c-11.54-103.24-26.11-192.08-43.31-264.07   c-21.88-91.47-48.39-146.93-76.66-160.37c-9.46-4.5-19.31-4.35-29.28,0.44l-1.23-2.55c10.78-5.18,21.45-5.33,31.72-0.45   c29.48,14.02,55.79,68.62,78.2,162.27c17.23,72.1,31.82,161.06,43.37,264.42c3.21,28.75,7.9,61.38,18.25,85.35   c6.31,14.58,13.28,26.39,21.31,36.11l0.19,0.23l0.08,0.28c8.6,29.92,20.55,43.34,35.52,39.89c20.12-4.64,37.97-13.68,56.87-23.26   c11.19-5.67,22.75-11.53,34.76-16.34c22.51-9.02,45.98-15.29,69.76-18.62c31.63-4.4,63.35-3.07,91.73,3.83   c56.39,13.57,103.38,47.59,143.01,78.42c4.06,3.16,8.09,6.33,12.1,9.48c4.75,3.74,9.67,7.6,14.49,11.33   c3.73,2.89,8.04,6.1,12.12,7.68c5.95,2.28,10.31,1.88,14.16,1.53c0.74-0.07,1.45-0.13,2.15-0.18c20.86-1.33,42.87,1.2,75.95,8.73   c40.84,9.28,74.22,23.96,102.05,44.85c19.67,14.76,37.97,33.21,55.67,51.06c8.92,8.98,18.13,18.28,27.44,27.02   c7.36,6.91,15.01,13.65,22.73,20.04c44.41,36.57,73.59,42.13,91.69,43.12c36.75,2.04,77.99-18.71,110.32-55.51   c3.84-4.37,7.64-8.79,11.31-13.05c24.74-28.76,48.11-55.92,84.44-70.3c12.29-4.85,26.92-8.02,44.75-9.69   c23.71-2.3,47.6-1.53,71.01,2.31c37.96,6.38,74.98,21.08,110.06,43.68c17.13,10.99,33.49,23.33,49.31,35.26   c15.93,12.02,30.98,23.37,44.6,31.57c3.14,1.89,6.12,3.62,9,5.29l2.37,1.38c20.77,12.05,36.17,20.29,60.1,24.78   c13.61,2.56,29.65,3.39,47.66,2.48c18.56-0.96,35.03-3.24,50.35-6.99c12.62-3.08,25.4-7.42,37.76-11.61   c28.48-9.67,57.94-19.66,86.86-14.62c3.75,0.65,7.49,1.55,11.13,2.67c17.1,5.3,31.29,16.59,45,27.51c3.06,2.44,6.23,4.96,9.35,7.35   c11.79,9.04,27.44-3.82,51.13-23.28c5.58-4.58,11.35-9.32,17.71-14.32c6.38-5.01,13.26-10.1,20.55-15.48   c27.83-20.56,62.46-46.14,93.57-86.87c7.94-10.39,15.47-22.8,22.76-34.8c10.24-16.87,20.83-34.3,33-47.07   c131.35-137.72,217.61-207.49,256.53-207.49c0.94,0,1.85,0.04,2.73,0.12c6.82,0.63,12.06,3.68,15.58,9.07l-2.37,1.55   c-3.07-4.7-7.47-7.25-13.47-7.8c-36.09-3.33-124.94,68.09-256.95,206.5c-11.96,12.55-22.47,29.85-32.63,46.59   c-7.32,12.06-14.9,24.53-22.92,35.05c-31.35,41.05-66.16,66.77-94.14,87.43c-7.27,5.37-14.14,10.44-20.49,15.43   c-6.34,4.98-12.1,9.71-17.66,14.29C1631.17,461.6,1617.2,473.07,1605.62,473.07z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000164495530219766942560000011877754606805399740_",
    gradientUnits: "userSpaceOnUse",
    x1: -341.2871,
    y1: 43.0171,
    x2: 2103.0425,
    y2: 43.0171
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2681,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3068,
    style: {
      stopColor: "#E8FAF7",
      stopOpacity: 0.0528
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3871,
    style: {
      stopColor: "#BDF1E9",
      stopOpacity: 0.1627
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4716,
    style: {
      stopColor: "#98E9DD",
      stopOpacity: 0.2782
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5594,
    style: {
      stopColor: "#7AE2D3",
      stopOpacity: 0.3982
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6515,
    style: {
      stopColor: "#62DDCB",
      stopOpacity: 0.5241
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7498,
    style: {
      stopColor: "#52DAC5",
      stopOpacity: 0.6586
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8588,
    style: {
      stopColor: "#48D8C2",
      stopOpacity: 0.8076
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9995,
    style: {
      stopColor: "#45D7C1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "url(#SVGID_00000164495530219766942560000011877754606805399740_)"
    },
    d: "M699.86,466.89   c-1.9,0-3.8-0.05-5.69-0.16c-29.76-1.69-59.65-15.64-94.04-43.9c-7.61-6.25-15.36-13.08-23.04-20.29   c-8.97-8.44-17.85-17.38-26.44-26.03c-18.18-18.31-36.98-37.23-57.29-51.96c-28.62-20.73-63.42-34.25-103.43-40.2   c-31.28-4.64-53.92-4.85-75.71-0.7c-0.6,0.11-1.2,0.24-1.82,0.37c-4.01,0.84-9.01,1.88-15.91-0.48c-4.55-1.56-8.96-4.76-13.09-7.9   c-6.62-5.02-13.34-10.28-19.84-15.36c-2.34-1.83-4.68-3.66-7.03-5.49c-44.45-34.64-88.74-66.85-141.89-80.4   c-28.19-7.25-59.72-8.74-91.17-4.29c-23.72,3.36-47.06,9.81-69.38,19.18c-12.02,5.06-23.61,11.29-34.81,17.31   c-18.01,9.68-36.62,19.69-57.01,24.71c-5.26,1.29-10.16,0.57-14.58-2.17c-9.03-5.59-16.2-19.86-21.3-42.4   c-7.25-10.25-13.58-22.72-19.36-38.12c-9.41-25.1-13.24-58.25-15.74-87.37c-5.98-69.77-17.05-172.76-35.78-267.17   c-19.49-98.37-43-155.21-69.87-168.92c-8.21-4.19-16.88-4.24-25.75-0.15l-1.19-2.57c9.71-4.47,19.21-4.4,28.23,0.2   c27.68,14.12,51.69,71.62,71.36,170.89c18.76,94.54,29.83,197.63,35.82,267.48c2.49,28.93,6.28,61.84,15.57,86.62   c5.73,15.29,12,27.62,19.18,37.71l0.17,0.23l0.06,0.28c4.93,21.94,11.69,35.69,20.09,40.89c3.8,2.35,7.86,2.95,12.41,1.83   c20.03-4.94,37.67-14.42,56.34-24.46c11.26-6.05,22.91-12.31,35.06-17.43c22.54-9.47,46.12-15.99,70.08-19.38   c31.82-4.5,63.73-3,92.27,4.35c53.67,13.69,98.23,46.08,142.93,80.91c2.35,1.83,4.69,3.66,7.03,5.49   c6.49,5.08,13.2,10.33,19.81,15.34c3.95,3,8.14,6.05,12.29,7.47c6.16,2.11,10.54,1.19,14.41,0.39c0.64-0.13,1.27-0.26,1.88-0.38   c22.11-4.21,45.04-4.01,76.65,0.68c40.47,6.02,75.69,19.71,104.68,40.71c20.5,14.86,39.38,33.87,57.64,52.26   c8.57,8.63,17.44,17.56,26.37,25.96c7.63,7.17,15.33,13.95,22.89,20.16c33.91,27.86,63.27,41.6,92.4,43.26   c20.04,1.15,40.66-3.97,61.28-15.2c18.19-9.91,35.39-24.15,49.72-41.17c4.65-5.53,9.19-11.11,13.58-16.51   c22.89-28.18,44.51-54.8,79.14-69.28c12.19-5.08,26.33-8.33,44.48-10.21c23.59-2.53,47.41-2.06,70.78,1.39   c37.99,5.77,75.13,19.64,110.39,41.24c15.68,9.54,30.84,20.23,45.5,30.56c17.86,12.59,34.72,24.49,49.88,32.34   c4.25,2.19,8.33,4.15,11.6,5.73c21.5,10.36,36.72,15.99,60.21,17.99c13.92,1.18,29.79,0.97,47.17-0.64   c19.29-1.8,35.19-4.38,50.04-8.09c11.67-2.91,23.54-6.79,35.01-10.54c29.35-9.6,59.71-19.52,89.39-14.09   c3.74,0.67,7.46,1.59,11.07,2.72c17,5.33,31.21,16.39,44.96,27.09c3.09,2.41,6.29,4.89,9.45,7.26   c14.25,10.67,37.73-0.34,69.79-32.74l0.18-0.18l0.23-0.11c28.82-13.24,72.47-40.6,116.79-95.78c8.14-10.12,15.82-22.37,23.24-34.22   c10.45-16.67,21.26-33.9,33.8-46.11c64.13-62.39,119.33-109.88,164.07-141.17c43.46-30.39,76.13-44.82,97.07-42.88   c8.7,0.8,15.4,4.45,19.9,10.84l-2.32,1.63c-4.01-5.68-10.01-8.92-17.85-9.65c-41.5-3.82-133.49,61.24-258.9,183.25   c-12.3,11.96-23.02,29.05-33.38,45.58c-7.47,11.91-15.2,24.23-23.44,34.49c-44.54,55.46-88.48,83.07-117.58,96.47   c-33.59,33.89-57.58,44.63-73.33,32.83c-3.18-2.38-6.39-4.88-9.49-7.29c-13.55-10.54-27.56-21.44-44.06-26.62   c-3.5-1.09-7.11-1.98-10.73-2.64c-28.98-5.3-58.98,4.51-88,14c-11.52,3.77-23.43,7.66-35.2,10.6c-14.99,3.75-31.02,6.35-50.46,8.17   c-17.54,1.62-33.58,1.84-47.67,0.64c-23.93-2.04-39.38-7.75-61.19-18.26c-3.29-1.58-7.38-3.55-11.67-5.76   c-15.33-7.94-32.27-19.89-50.21-32.54c-14.62-10.31-29.74-20.97-45.34-30.46c-34.94-21.4-71.72-35.15-109.33-40.86   c-23.13-3.42-46.7-3.88-70.06-1.38c-17.88,1.86-31.76,5.04-43.69,10.01c-33.97,14.2-55.38,40.55-78.03,68.45   c-4.4,5.41-8.94,11.01-13.61,16.55c-14.56,17.3-32.03,31.76-50.53,41.84C737.82,461.62,718.63,466.89,699.86,466.89z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124859975987604874760000000022687800996461706_",
    gradientUnits: "userSpaceOnUse",
    x1: -338.8975,
    y1: 40.229,
    x2: 2095.4546,
    y2: 40.229
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2681,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3068,
    style: {
      stopColor: "#E8FAF7",
      stopOpacity: 0.0528
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3871,
    style: {
      stopColor: "#BDF1E9",
      stopOpacity: 0.1627
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4716,
    style: {
      stopColor: "#98E9DD",
      stopOpacity: 0.2782
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5594,
    style: {
      stopColor: "#7AE2D3",
      stopOpacity: 0.3982
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6515,
    style: {
      stopColor: "#62DDCB",
      stopOpacity: 0.5241
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7498,
    style: {
      stopColor: "#52DAC5",
      stopOpacity: 0.6586
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8588,
    style: {
      stopColor: "#48D8C2",
      stopOpacity: 0.8076
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9995,
    style: {
      stopColor: "#45D7C1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "url(#SVGID_00000124859975987604874760000000022687800996461706_)"
    },
    d: "M682.83,466.1   c-1.98,0-3.96-0.06-5.95-0.18c-30.1-1.75-60.2-15.74-94.75-44.02c-7.66-6.27-15.47-13.14-23.22-20.42   c-8.71-8.19-17.33-16.87-25.67-25.26c-18.62-18.74-37.88-38.12-58.91-52.83c-37.42-26.17-78.23-34.05-105.89-36.06   c-30.24-2.19-53.77,0.04-76.29,7.25c-0.46,0.15-0.92,0.3-1.39,0.46c-4.11,1.38-9.22,3.1-16.54,0.9c-4.65-1.4-9.32-4.71-13.33-7.7   c-8.65-6.43-17.38-13.26-25.83-19.86l-1.3-1.02c-42.93-33.54-87.32-68.22-141.85-82.9c-28.35-7.7-60.05-9.36-91.67-4.82   c-23.88,3.43-47.31,10.14-69.65,19.96c-12.14,5.36-23.79,11.98-35.05,18.38c-17.81,10.12-36.22,20.59-56.55,25.93   c-4.84,1.27-9.33,0.61-13.34-1.98c-8.83-5.69-15.43-21.02-19.61-45.56c-6.37-10.54-11.99-23.53-17.18-39.7   c-8.26-25.74-11.23-59.22-13.04-88.57c-5.9-96.93-15.94-192.92-28.27-270.3c-16.58-104.06-37.71-163.79-62.8-177.52   c-7.18-3.93-14.54-4.15-22.49-0.68l-1.13-2.6c8.69-3.79,17.1-3.52,24.99,0.79c26.27,14.38,47.28,73.11,64.24,179.56   c12.35,77.47,22.4,173.56,28.3,270.57c1.8,29.18,4.74,62.44,12.91,87.88c5.16,16.08,10.73,28.94,17.04,39.33l0.14,0.23l0.05,0.27   c4.05,23.88,10.24,38.66,18.4,43.92c3.36,2.17,6.98,2.7,11.09,1.62c19.97-5.24,37.41-15.16,55.87-25.65   c11.32-6.44,23.03-13.1,35.31-18.51c22.57-9.92,46.25-16.71,70.39-20.17c32-4.6,64.1-2.91,92.82,4.89   c55.08,14.82,99.7,49.69,142.85,83.4l1.3,1.02c8.43,6.59,17.15,13.41,25.78,19.82c3.82,2.85,8.25,5.99,12.46,7.26   c6.46,1.95,10.9,0.45,14.81-0.87c0.49-0.17,0.97-0.33,1.43-0.48c22.89-7.32,46.75-9.6,77.36-7.38   c28.01,2.03,69.36,10.02,107.31,36.56c21.24,14.86,40.59,34.33,59.3,53.16c8.32,8.37,16.93,17.03,25.6,25.19   c7.7,7.23,15.47,14.06,23.08,20.29c34.06,27.88,63.65,41.67,93.12,43.38c46.11,2.72,87.91-27.76,111.65-57.2   c5.25-6.51,10.29-13.12,15.17-19.51c21.25-27.82,41.32-54.1,74.51-68.72c11.94-5.25,25.99-8.66,44.21-10.74   c23.48-2.74,47.22-2.58,70.56,0.48c37.98,5.17,75.26,18.23,110.79,38.82c14.38,8.28,28.42,17.54,42.01,26.5   c19.66,12.96,38.23,25.21,54.82,32.46c3.45,1.55,6.75,2.83,9.94,4.07l1.83,0.71c22.67,8.73,37.3,11.44,60.31,11.19   c15.52-0.3,31.23-1.57,46.66-3.77c14.48-1.96,31.7-4.59,49.75-9.21c10.61-2.71,21.42-6.12,31.87-9.41   c30.36-9.57,61.74-19.47,92.32-13.63c3.7,0.7,7.41,1.63,11.01,2.76c16.93,5.36,31.22,16.24,45.04,26.75   c3.09,2.35,6.28,4.78,9.42,7.08c14.99,10.98,38.84,1.56,70.91-28.02l0.2-0.18l0.25-0.1c29.74-11.35,74.63-36.07,119.65-89.34   c8.33-9.86,16.16-21.95,23.73-33.64c10.66-16.47,21.68-33.51,34.59-45.14c120.46-108.59,213.37-165.88,261.57-161.3   c11.21,1.06,19.84,5.5,25.66,13.18l-2.26,1.71c-5.32-7.02-13.28-11.08-23.66-12.07c-27.47-2.6-97.68,14.79-259.41,160.59   c-12.62,11.38-23.54,28.25-34.1,44.57c-7.62,11.77-15.49,23.94-23.94,33.93c-45.28,53.58-90.5,78.55-120.55,90.06   c-33.57,30.91-57.88,40.08-74.31,28.04c-3.17-2.32-6.37-4.76-9.46-7.11c-13.63-10.37-27.72-21.09-44.18-26.3   c-3.5-1.1-7.09-2-10.69-2.68c-29.87-5.7-60.91,4.09-90.93,13.55c-10.49,3.31-21.34,6.73-32.02,9.46   c-18.18,4.65-35.51,7.29-50.06,9.27c-15.54,2.21-31.36,3.49-47.01,3.79c-23.12,0.26-38.6-2.61-61.37-11.38l-1.83-0.71   c-3.22-1.25-6.56-2.55-10.06-4.12c-16.8-7.34-35.47-19.65-55.23-32.69c-13.55-8.93-27.55-18.17-41.86-26.41   c-35.21-20.41-72.14-33.35-109.75-38.46c-23.1-3.03-46.6-3.19-69.86-0.48c-17.94,2.05-31.73,5.4-43.4,10.52   c-32.52,14.33-52.37,40.32-73.39,67.84c-4.89,6.4-9.95,13.02-15.22,19.57C767.73,436.4,727.62,466.1,682.83,466.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083782953630301913880000012217399140081566636_",
    gradientUnits: "userSpaceOnUse",
    x1: -336.4766,
    y1: 37.3923,
    x2: 2087.8481,
    y2: 37.3923
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2681,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3068,
    style: {
      stopColor: "#E8FAF7",
      stopOpacity: 0.0528
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3871,
    style: {
      stopColor: "#BDF1E9",
      stopOpacity: 0.1627
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4716,
    style: {
      stopColor: "#98E9DD",
      stopOpacity: 0.2782
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5594,
    style: {
      stopColor: "#7AE2D3",
      stopOpacity: 0.3982
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6515,
    style: {
      stopColor: "#62DDCB",
      stopOpacity: 0.5241
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7498,
    style: {
      stopColor: "#52DAC5",
      stopOpacity: 0.6586
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8588,
    style: {
      stopColor: "#48D8C2",
      stopOpacity: 0.8076
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9995,
    style: {
      stopColor: "#45D7C1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "url(#SVGID_00000083782953630301913880000012217399140081566636_)"
    },
    d: "M665.49,465.31   c-2.02,0-4.03-0.06-6.03-0.18c-30.44-1.83-60.78-15.85-95.47-44.15c-7.69-6.27-15.55-13.18-23.36-20.53   c-8.45-7.95-16.83-16.38-24.92-24.52c-19.06-19.17-38.77-39-60.52-53.68c-39.09-26.39-80.49-31.92-108.34-31.92   c-29.98,0-53.69,4.69-76.87,15.2c-0.37,0.17-0.75,0.34-1.13,0.52c-4.15,1.93-9.32,4.33-16.98,2.32c-4.76-1.25-9.51-4.52-13.6-7.5   c-9.3-6.79-18.63-14.05-27.39-20.92l-5.38-4.22c-43.68-34.25-84.93-66.6-136.42-81.17c-28.55-8.13-60.42-9.97-92.16-5.33   c-24.03,3.5-47.54,10.47-69.87,20.74c-12.26,5.66-23.97,12.68-35.29,19.47c-17.61,10.56-35.82,21.48-56.08,27.14   c-4.46,1.24-8.56,0.64-12.2-1.79c-8.61-5.76-14.61-22.16-17.82-48.74c-5.61-10.96-10.38-24.09-15.01-41.26   c-7.21-26.72-9.28-62.01-10.28-89.77c-3.45-94.74-10.83-191.86-20.79-273.46c-13.64-111.47-31.78-172.4-55.47-186.26   c-6.15-3.6-12.52-3.95-19.5-1.08l-1.08-2.62c7.74-3.19,15.15-2.76,22.01,1.25c24.5,14.34,43.1,75.95,56.85,188.36   c9.96,81.68,17.35,178.88,20.81,273.7c0.99,27.61,3.05,62.69,10.18,89.14c4.61,17.1,9.35,30.11,14.91,40.93l0.12,0.23l0.03,0.25   c3.1,25.87,8.69,41.67,16.61,46.97c2.96,1.98,6.18,2.44,9.86,1.41c19.9-5.56,37.14-15.9,55.39-26.84   c11.39-6.83,23.16-13.89,35.56-19.62c22.58-10.38,46.35-17.44,70.65-20.97c32.13-4.7,64.41-2.83,93.34,5.41   c52.02,14.73,93.49,47.24,137.39,81.67l5.38,4.22c8.74,6.85,18.05,14.1,27.32,20.86c3.87,2.82,8.36,5.93,12.65,7.05   c6.67,1.75,11.13-0.32,15.06-2.15c0.39-0.18,0.78-0.36,1.15-0.53c23.57-10.69,47.64-15.45,78.04-15.45   c28.25,0,70.25,5.62,109.93,32.41c21.98,14.84,41.79,34.76,60.94,54.03c8.08,8.13,16.44,16.54,24.86,24.46   c7.76,7.3,15.57,14.16,23.21,20.4c34.21,27.9,64.03,41.73,93.85,43.52c20.36,1.24,42-4.04,62.56-15.27   c18.95-10.35,36.17-25.14,49.8-42.77c5.78-7.48,11.24-15.1,16.52-22.46c19.7-27.49,38.31-53.45,70.13-68.21   c11.75-5.42,25.72-9,43.95-11.27c23.37-3,47.04-3.18,70.34-0.52c38.02,4.59,75.42,16.84,111.15,36.41   c13.22,7.2,26.25,15.23,38.85,23c21.34,13.16,41.49,25.58,59.42,32.02c4.58,1.65,8.81,2.92,11.98,3.85   c23.41,6.83,38.14,6.86,60.43,4.4c13.24-1.46,28.77-3.78,46.18-6.91c14.98-2.69,31.96-5.74,49.44-10.32   c9.39-2.45,18.99-5.37,28.27-8.2c31.52-9.6,64.12-19.54,95.73-13.23c3.69,0.74,7.37,1.7,10.93,2.85   c16.82,5.38,31.14,16.03,45,26.33c3.12,2.32,6.34,4.71,9.52,6.99c15.72,11.27,39.96,3.43,72.04-23.31l0.22-0.18l0.27-0.08   c30.63-9.43,76.76-31.47,122.53-82.91c8.53-9.59,16.5-21.52,24.21-33.07c10.87-16.28,22.11-33.12,35.38-44.17   c114.19-95.2,206.54-144.69,260.09-139.38c14.55,1.45,25.75,6.94,33.32,16.33l-2.21,1.78c-7.07-8.78-17.63-13.92-31.39-15.29   c-30.55-3.04-104.7,10.95-257.99,138.73c-12.95,10.78-24.07,27.45-34.83,43.56c-7.76,11.62-15.79,23.64-24.45,33.38   c-46.07,51.77-92.56,74.06-123.54,83.65c-33.55,27.91-58.18,35.52-75.29,23.25c-3.2-2.3-6.43-4.7-9.55-7.02   c-13.67-10.16-27.8-20.67-44.17-25.91c-3.46-1.12-7.03-2.05-10.62-2.77c-30.9-6.16-63.15,3.66-94.34,13.16   c-9.31,2.84-18.93,5.77-28.38,8.23c-17.58,4.6-34.62,7.67-49.65,10.37c-17.47,3.14-33.07,5.47-46.37,6.93   c-22.19,2.45-37.8,2.43-61.53-4.49c-3.21-0.94-7.49-2.22-12.15-3.9c-18.21-6.54-38.49-19.04-59.95-32.28   c-12.57-7.75-25.56-15.76-38.72-22.93c-35.42-19.4-72.47-31.54-110.13-36.09c-23.07-2.63-46.5-2.46-69.66,0.52   c-17.94,2.23-31.63,5.73-43.11,11.03c-31.14,14.44-49.54,40.11-69.02,67.29c-5.29,7.39-10.77,15.03-16.58,22.54   c-13.86,17.94-31.39,32.99-50.68,43.52C704.53,459.9,684.59,465.31,665.49,465.31z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelleNeuHintenNeu);
export default __webpack_public_path__ + "static/media/Welle_neu_hinten_neu.b45955811134c3b1086fb710a9f49d83.svg";
export { ForwardRef as ReactComponent };